import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { getErrorMessage } from '../../lib/utils';
import GestorLayout from '../../components/GestorLayout';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { 
  AlertTriangle, Package, CheckCircle, XCircle, Clock,
  FileText, RefreshCw, ChevronDown, ChevronUp, Filter,
  TrendingUp, Activity, Search, Bell, ArrowRight, Wrench,
  RotateCcw, Eye, Download, CheckCheck, Trash2, Edit, User,
  ArrowUpDown, SortAsc, SortDesc, Calendar, Info, Camera, Image, MessageSquare,
  Send, FileOutput, Truck, GripVertical, X, AlertCircle, CheckCircle2, Plus,
  LayoutGrid, List
} from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../components/ui/dialog';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '../../components/ui/sheet';
import AnomaliasGrelha from '../../components/anomalias/AnomaliasGrelha';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function DashboardAnomalias() {
  const [loading, setLoading] = useState(true);
  const [anomalias, setAnomalias] = useState([]);
  const [resgates, setResgates] = useState([]);
  const [ofs, setOfs] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState('todos');
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedOf, setExpandedOf] = useState(null);
  const [showHistoricoDialog, setShowHistoricoDialog] = useState(false);
  const [historicoSelecionado, setHistoricoSelecionado] = useState(null);
  const [showResgateSheet, setShowResgateSheet] = useState(false);
  const [resgateSelecionado, setResgateSelecionado] = useState(null);
  const [showReinserirDialog, setShowReinserirDialog] = useState(false);
  const [reinserirData, setReinserirData] = useState({ quantidade: 0, observacao: '', operacao_destino_id: '' });
  const [operacaoParaMarcar, setOperacaoParaMarcar] = useState(null);
  const [historicoMovimentacoes, setHistoricoMovimentacoes] = useState([]);
  const [showHistoricoMovimentacoes, setShowHistoricoMovimentacoes] = useState(false);
  const [resgateOrdem, setResgateOrdem] = useState('data_desc'); // data_desc, data_asc, qtd_desc, qtd_asc, status
  const [resgateFiltroPesquisa, setResgateFiltroPesquisa] = useState(''); // Pesquisa por OF ou número do resgate
  const [resgateFiltroStatus, setResgateFiltroStatus] = useState('todos'); // todos, em_arranjo, parcial, concluido
  const [vistaResgates, setVistaResgates] = useState('grelha'); // 'grelha' | 'lista'
  const [showEditResgateDialog, setShowEditResgateDialog] = useState(false);
  const [editResgateData, setEditResgateData] = useState({ observacoes: '', status: '', prioridade: 2 });
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [anomaliaSelecionada, setAnomaliaSelecionada] = useState(null);
  const [showAnomaliaDetail, setShowAnomaliaDetail] = useState(false);
  const [tipoFiltroAnomalia, setTipoFiltroAnomalia] = useState('todos'); // todos, defeito, arranjo
  const [mostrarArquivadas, setMostrarArquivadas] = useState(false); // Filtro para mostrar/esconder arquivadas
  const [mostrarResumos, setMostrarResumos] = useState(true); // Toggle para ocultar resumos/contadores
  
  // Estados para Criar Resgate
  const [showCriarResgateModal, setShowCriarResgateModal] = useState(false);
  const [anomaliasSelecionadasParaResgate, setAnomaliasSelecionadasParaResgate] = useState({});
  const [nomeResgate, setNomeResgate] = useState(''); // Nome personalizado do resgate
  const [categorias, setCategorias] = useState([]);
  const [ofSelecionadaResgate, setOfSelecionadaResgate] = useState(''); // OF selecionada no modal de resgate (fluxo OF-first)
  const [searchOFResgate, setSearchOFResgate] = useState(''); // Pesquisa de OF no modal de resgate
  
  // Estados para Adicionar Arranjo/Defeito Manualmente
  const [showAdicionarAnomaliaModal, setShowAdicionarAnomaliaModal] = useState(false);
  const [searchOFAnomalia, setSearchOFAnomalia] = useState(''); // Pesquisa de OF
  const [novaAnomalia, setNovaAnomalia] = useState({
    of_id: '',
    lote_id: '',
    operacao_id: '',
    tipo: 'arranjo', // arranjo ou defeito
    quantidade: 1,
    razao: '',
    observacoes: ''
  });
  const [lotesOFSelecionada, setLotesOFSelecionada] = useState([]);
  const [operacoesOFSelecionada, setOperacoesOFSelecionada] = useState([]);
  
  // Classificação de Perda para Defeitos resgatados
  const MOTIVOS_PERDA = [
    { id: 'material_defeituoso', label: 'Material Defeituoso' },
    { id: 'erro_corte', label: 'Erro de Corte' },
    { id: 'erro_costura', label: 'Erro de Costura' },
    { id: 'mancha', label: 'Mancha/Sujidade' },
    { id: 'desgaste', label: 'Desgaste Excessivo' },
    { id: 'medidas_erradas', label: 'Medidas Erradas' },
    { id: 'rasgao', label: 'Rasgão/Furo' },
    { id: 'acabamento', label: 'Problema de Acabamento' },
    { id: 'outro', label: 'Outro' }
  ];

  // Tipos de Arranjo para classificação
  const TIPOS_ARRANJO = [
    { id: 'costura', label: 'Arranjo de Costura' },
    { id: 'corte', label: 'Arranjo de Corte' },
    { id: 'lavagem', label: 'Arranjo de Lavagem' },
    { id: 'passagem', label: 'Arranjo de Passagem a Ferro' },
    { id: 'remendo', label: 'Remendo' },
    { id: 'limpeza', label: 'Limpeza/Remoção de Mancha' },
    { id: 'ajuste', label: 'Ajuste de Medidas' },
    { id: 'acabamento', label: 'Arranjo de Acabamento' },
    { id: 'outro', label: 'Outro Arranjo' }
  ];
  
  // Estados para Guias de Terceirização
  const [showGuiaTerceirizacao, setShowGuiaTerceirizacao] = useState(false);
  const [guiasResgate, setGuiasResgate] = useState([]);
  const [novaGuia, setNovaGuia] = useState({
    numero_guia: '',
    quantidade: 0,
    descricao: '',
    nome_confecao: ''
  });
  const [guiaSelecionada, setGuiaSelecionada] = useState(null);
  const [showEditGuia, setShowEditGuia] = useState(false);
  const [showDeleteGuiaConfirm, setShowDeleteGuiaConfirm] = useState(false);
  const [guiaParaEliminar, setGuiaParaEliminar] = useState(null);
  const [editGuiaData, setEditGuiaData] = useState({
    entregas: [
      { data: '', quantidade_recebida: 0, observacoes: '' },
      { data: '', quantidade_recebida: 0, observacoes: '' },
      { data: '', quantidade_recebida: 0, observacoes: '' }
    ],
    pecas_com_defeito: 0,
    observacoes_finais: ''
  });
  
  // Estatísticas
  const [stats, setStats] = useState({
    totalAnomalias: 0,
    totalDefeitos: 0,
    totalArranjos: 0,
    emArranjo: 0,
    recuperadas: 0,
    descartadas: 0,
    resgatesAtivos: 0
  });
  const [operacoes, setOperacoes] = useState([]);
  const [showFotoDialog, setShowFotoDialog] = useState(false);
  const [fotoSelecionada, setFotoSelecionada] = useState(null);
  
  // Estados para Editar/Apagar/Arquivar Anomalias
  const [showEditAnomaliaDialog, setShowEditAnomaliaDialog] = useState(false);
  const [editAnomaliaData, setEditAnomaliaData] = useState({
    quantidade: 0,
    observacoes: '',
    razao: ''
  });
  const [showDeleteAnomaliaConfirm, setShowDeleteAnomaliaConfirm] = useState(false);
  const [showArquivarAnomaliaConfirm, setShowArquivarAnomaliaConfirm] = useState(false);
  const [anomaliaParaAcao, setAnomaliaParaAcao] = useState(null);
  
  // Estados para Tab Ativa (Dashboard ou Tipos)
  const [activeTab, setActiveTab] = useState('dashboard');
  
  // Estados para Tipos de Anomalias
  const [tiposAnomalia, setTiposAnomalia] = useState([]);
  const [showTipoDialog, setShowTipoDialog] = useState(false);
  const [editingTipo, setEditingTipo] = useState(null);
  const [tipoForm, setTipoForm] = useState({
    nome: '',
    codigo: '',
    cor: '#ef4444',
    descricao: '',
    classificacao: 'defeito'
  });
  
  // Estados para drag and drop de tipos
  const [draggedTipo, setDraggedTipo] = useState(null);
  const [dragOverTipo, setDragOverTipo] = useState(null);

  // Classificação e cores para tipos
  const CLASSIFICACAO_ANOMALIA = [
    { id: 'defeito', label: 'Defeito (Perda Total)', description: 'Peça não pode ser recuperada', color: 'bg-red-100 text-red-700 border-red-300' },
    { id: 'arranjo', label: 'Para Arranjo', description: 'Peça pode ser recuperada', color: 'bg-amber-100 text-amber-700 border-amber-300' }
  ];
  
  const CORES_DISPONIVEIS = [
    { value: '#ef4444', label: 'Vermelho' },
    { value: '#f97316', label: 'Laranja' },
    { value: '#eab308', label: 'Amarelo' },
    { value: '#22c55e', label: 'Verde' },
    { value: '#3b82f6', label: 'Azul' },
    { value: '#8b5cf6', label: 'Roxo' },
    { value: '#ec4899', label: 'Rosa' },
    { value: '#6b7280', label: 'Cinza' }
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const [anomaliasRes, resgatesRes, ofsRes, historicoRes, operacoesRes, categoriasRes, tiposRes] = await Promise.all([
        axios.get(`${API}/anomalias-producao`),
        axios.get(`${API}/resgates`),
        axios.get(`${API}/ofs`),
        axios.get(`${API}/historico-movimentacoes?limit=50`),
        axios.get(`${API}/operacoes`),
        axios.get(`${API}/categorias`),
        axios.get(`${API}/tipos-anomalia`)
      ]);
      
      // Validar que as respostas são arrays
      const anomaliasData = Array.isArray(anomaliasRes.data) ? anomaliasRes.data : [];
      const resgatesData = Array.isArray(resgatesRes.data) ? resgatesRes.data : [];
      const ofsData = Array.isArray(ofsRes.data) ? ofsRes.data : [];
      const historicoData = Array.isArray(historicoRes.data) ? historicoRes.data : [];
      const operacoesData = Array.isArray(operacoesRes.data) ? operacoesRes.data : [];
      const categoriasData = Array.isArray(categoriasRes.data) ? categoriasRes.data : [];
      const tiposData = Array.isArray(tiposRes.data) ? tiposRes.data : [];
      
      setAnomalias(anomaliasData);
      setResgates(resgatesData);
      setOfs(ofsData);
      setHistoricoMovimentacoes(historicoData);
      setOperacoes(operacoesData);
      setCategorias(categoriasData);
      setTiposAnomalia(tiposData);
      
      // Calcular estatísticas
      const defeitos = anomaliasData.filter(a => a.tipo === 'defeito');
      const arranjos = anomaliasData.filter(a => a.tipo === 'arranjo');
      
      setStats({
        totalAnomalias: anomaliasData.length,
        totalDefeitos: defeitos.reduce((acc, a) => acc + (a.quantidade || 0), 0),
        totalArranjos: arranjos.reduce((acc, a) => acc + (a.quantidade || 0), 0),
        emArranjo: anomaliasData.reduce((acc, a) => acc + (a.quantidade_em_arranjo || 0), 0),
        recuperadas: anomaliasData.reduce((acc, a) => acc + (a.quantidade_recuperada || 0), 0),
        descartadas: anomaliasData.reduce((acc, a) => acc + (a.quantidade_descartada || 0), 0),
        resgatesAtivos: resgatesData.filter(r => r.status !== 'concluido').length
      });
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      toast.error('Erro ao carregar dados');
    } finally {
      setLoading(false);
    }
  };

  // Funções para gerir Tipos de Anomalias
  const resetTipoForm = () => {
    setTipoForm({
      nome: '',
      codigo: '',
      cor: '#ef4444',
      descricao: '',
      classificacao: 'defeito'
    });
    setEditingTipo(null);
  };

  const handleSaveTipo = async () => {
    try {
      if (!tipoForm.nome.trim()) {
        toast.error('O nome do tipo é obrigatório');
        return;
      }
      if (!tipoForm.codigo.trim()) {
        toast.error('O código do tipo é obrigatório');
        return;
      }

      if (editingTipo) {
        await axios.put(`${API}/tipos-anomalia/${editingTipo.id}`, tipoForm);
        toast.success('Tipo de anomalia atualizado');
      } else {
        await axios.post(`${API}/tipos-anomalia`, tipoForm);
        toast.success('Tipo de anomalia criado');
      }
      
      setShowTipoDialog(false);
      resetTipoForm();
      loadData();
    } catch (err) {
      toast.error(getErrorMessage(err, 'Erro ao guardar tipo de anomalia'));
    }
  };

  const openEditTipo = (tipo) => {
    setEditingTipo(tipo);
    setTipoForm({
      nome: tipo.nome,
      codigo: tipo.codigo || '',
      cor: tipo.cor,
      descricao: tipo.descricao || '',
      classificacao: tipo.classificacao || 'defeito'
    });
    setShowTipoDialog(true);
  };

  const handleDeleteTipo = async (tipoId) => {
    if (!window.confirm('Tem a certeza que deseja eliminar este tipo de anomalia?')) return;
    
    try {
      await axios.delete(`${API}/tipos-anomalia/${tipoId}`);
      toast.success('Tipo de anomalia eliminado');
      loadData();
    } catch (err) {
      toast.error(getErrorMessage(err, 'Erro ao eliminar tipo de anomalia'));
    }
  };

  // Funções de Drag and Drop para ordenação de tipos
  const handleTipoDragStart = (e, tipo) => {
    setDraggedTipo(tipo);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleTipoDragOver = (e, tipo) => {
    e.preventDefault();
    if (draggedTipo && draggedTipo.id !== tipo.id && draggedTipo.classificacao === tipo.classificacao) {
      setDragOverTipo(tipo.id);
    }
  };

  const handleTipoDragLeave = () => {
    setDragOverTipo(null);
  };

  const handleTipoDrop = async (e, targetTipo) => {
    e.preventDefault();
    setDragOverTipo(null);
    
    if (!draggedTipo || draggedTipo.id === targetTipo.id) {
      setDraggedTipo(null);
      return;
    }
    
    // Só permitir reordenar dentro da mesma classificação
    if (draggedTipo.classificacao !== targetTipo.classificacao) {
      setDraggedTipo(null);
      return;
    }
    
    // Filtrar tipos da mesma classificação
    const tiposMesmaClassificacao = tiposAnomalia
      .filter(t => t.classificacao === draggedTipo.classificacao)
      .sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
    
    // Encontrar índices
    const dragIndex = tiposMesmaClassificacao.findIndex(t => t.id === draggedTipo.id);
    const targetIndex = tiposMesmaClassificacao.findIndex(t => t.id === targetTipo.id);
    
    // Reordenar
    const reordered = [...tiposMesmaClassificacao];
    const [removed] = reordered.splice(dragIndex, 1);
    reordered.splice(targetIndex, 0, removed);
    
    // Atualizar ordem no servidor
    try {
      await axios.put(`${API}/tipos-anomalia/reordenar`, {
        tipos_ids: reordered.map(t => t.id)
      });
      
      // Atualizar estado local
      const outrosTipos = tiposAnomalia.filter(t => t.classificacao !== draggedTipo.classificacao);
      const novosReordenados = reordered.map((t, i) => ({ ...t, ordem: i }));
      setTiposAnomalia([...outrosTipos, ...novosReordenados]);
      
      toast.success('Ordem atualizada');
    } catch (err) {
      toast.error('Erro ao reordenar');
    }
    
    setDraggedTipo(null);
  };

  const handleTipoDragEnd = () => {
    setDraggedTipo(null);
    setDragOverTipo(null);
  };

  // Carregar lotes e operações de uma OF específica (para adicionar anomalias)
  const loadOFDetails = async (ofId) => {
    if (!ofId) {
      setLotesOFSelecionada([]);
      setOperacoesOFSelecionada([]);
      return;
    }
    
    try {
      const of = ofs.find(o => o.id === ofId);
      if (!of) return;
      
      // Carregar lotes aprovados da OF
      const lotesRes = await axios.get(`${API}/ofs/${ofId}/lotes`);
      const lotesData = lotesRes.data?.lotes || lotesRes.data || [];
      const lotesAprovados = Array.isArray(lotesData) 
        ? lotesData.filter(l => l.status === 'aprovado') 
        : [];
      setLotesOFSelecionada(lotesAprovados);
      
      // Obter operações da OF
      const operacoesOF = (of.operacoes || []).map(opOF => {
        const opInfo = operacoes.find(op => op.id === opOF.operacao_id);
        return {
          ...opOF,
          id: opOF.operacao_id,
          nome: opInfo?.nome || 'Operação desconhecida',
          codigo: opInfo?.codigo || ''
        };
      });
      setOperacoesOFSelecionada(operacoesOF);
    } catch (err) {
      console.error('Erro ao carregar detalhes da OF:', err);
      setLotesOFSelecionada([]);
      setOperacoesOFSelecionada([]);
    }
  };
  
  // Handler para seleccionar OF no modal de adicionar anomalia
  const handleOFChangeAdicionarAnomalia = async (ofId) => {
    setNovaAnomalia(prev => ({
      ...prev,
      of_id: ofId,
      lote_id: '',
      operacao_id: ''
    }));
    await loadOFDetails(ofId);
  };
  
  // Handler para criar anomalia manualmente
  const handleCriarAnomaliaManual = async () => {
    // Validação - operação pode ser 'nao_especificar' ou um ID válido
    if (!novaAnomalia.of_id || !novaAnomalia.lote_id) {
      toast.error('Selecione a OF e o lote');
      return;
    }
    if (!novaAnomalia.operacao_id) {
      toast.error('Selecione uma operação ou marque "Não especificar"');
      return;
    }
    if (novaAnomalia.quantidade < 1) {
      toast.error('A quantidade deve ser pelo menos 1');
      return;
    }
    
    setLoading(true);
    try {
      // Se operação é "nao_especificar", enviar como null ou string especial
      const operacaoIdParaEnviar = novaAnomalia.operacao_id === 'nao_especificar' 
        ? null 
        : novaAnomalia.operacao_id;
      
      await axios.post(`${API}/anomalias-producao`, {
        of_id: novaAnomalia.of_id,
        lote_id: novaAnomalia.lote_id,
        operacao_id: operacaoIdParaEnviar,
        operador_id: 'gestor', // Criado pelo gestor
        tipo: novaAnomalia.tipo,
        quantidade: novaAnomalia.quantidade,
        razao: novaAnomalia.razao,
        observacoes: novaAnomalia.observacoes
      });
      
      toast.success(`${novaAnomalia.tipo === 'arranjo' ? 'Arranjo' : 'Defeito'} registado com sucesso!`);
      
      // Reset e reload
      setNovaAnomalia({
        of_id: '',
        lote_id: '',
        operacao_id: '',
        tipo: 'arranjo',
        quantidade: 1,
        razao: '',
        observacoes: ''
      });
      setLotesOFSelecionada([]);
      setOperacoesOFSelecionada([]);
      setShowAdicionarAnomaliaModal(false);
      await loadData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Erro ao criar anomalia'));
    } finally {
      setLoading(false);
    }
  };

  // Separar tipos por classificação
  const tiposDefeito = tiposAnomalia.filter(t => t.classificacao === 'defeito' || !t.classificacao);
  const tiposArranjo = tiposAnomalia.filter(t => t.classificacao === 'arranjo');

  // Agrupar anomalias por OF
  const anomaliasPorOf = anomalias.reduce((acc, anomalia) => {
    const ofId = anomalia.of_id;
    if (!acc[ofId]) {
      const of = ofs.find(o => o.id === ofId);
      acc[ofId] = {
        of_id: ofId,
        numero_of: of?.numero_of || 'OF Desconhecida',
        artigo: of?.artigo || '',
        cliente: of?.cliente || '',
        anomalias: []
      };
    }
    acc[ofId].anomalias.push(anomalia);
    return acc;
  }, {});

  // Filtrar OFs
  const ofsFiltradas = Object.values(anomaliasPorOf).filter(grupo => {
    // Filtro de pesquisa
    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      if (!grupo.numero_of.toLowerCase().includes(search) && 
          !grupo.artigo.toLowerCase().includes(search) &&
          !grupo.cliente.toLowerCase().includes(search)) {
        return false;
      }
    }
    
    // Filtrar anomalias do grupo para aplicar filtros
    const anomaliasFiltradas = grupo.anomalias.filter(a => {
      // Filtro de arquivadas
      if (!mostrarArquivadas && a.status === 'arquivado') return false;
      // Filtro de tipo
      if (filtroTipo !== 'todos' && a.tipo !== filtroTipo) return false;
      // Filtro de status
      if (filtroStatus !== 'todos' && a.status !== filtroStatus) return false;
      return true;
    });
    
    // Actualizar anomalias filtradas no grupo
    grupo.anomaliasFiltradas = anomaliasFiltradas;
    
    // Se não há anomalias após filtros, não mostrar o grupo
    return anomaliasFiltradas.length > 0;
  });

  // Calcular quantidade disponível para resgate (peças em arranjo/defeito ainda não resgatadas)
  const getQuantidadeDisponivelResgate = (anomalia) => {
    // Aceita arranjos (e defeitos legados) para terceirização.
    if (anomalia.tipo !== 'arranjo' && anomalia.tipo !== 'defeito') return 0;
    // Para arranjos, a "base" disponível é qtd_arranjo (peças já classificadas como arranjo).
    // Subtrai apenas o que já saiu do circuito de arranjo (recuperadas, terceirizadas, descartadas).
    // Peças em lote_arranjo (qtd_em_lote_arranjo) AINDA são candidatas a terceirização —
    // o backend trata a desalocação ao criar a terceirização.
    const recuperada = anomalia.qtd_recuperada || anomalia.quantidade_recuperada || 0;
    const descartada = anomalia.quantidade_descartada || 0;
    const terceirizada = anomalia.qtd_terceirizada || 0;
    let base;
    if (anomalia.tipo === 'arranjo') {
      base = anomalia.qtd_arranjo || anomalia.quantidade_arranjos || anomalia.quantidade || 0;
    } else {
      // defeito (legado)
      base = anomalia.qtd_defeito || anomalia.quantidade_defeitos || anomalia.quantidade || 0;
    }
    return Math.max(0, base - recuperada - descartada - terceirizada);
  };

  // Expandir anomalias que têm classificação de defeitos/arranjos em linhas separadas
  const expandirAnomalias = (anomalia) => {
    const defeitos = anomalia.quantidade_defeitos || 0;
    const arranjos = anomalia.quantidade_arranjos || 0;
    
    // Se não tem classificação, retornar a anomalia original
    if (defeitos === 0 && arranjos === 0) {
      return [anomalia];
    }
    
    const resultado = [];
    
    // Linha para defeitos
    if (defeitos > 0) {
      resultado.push({
        ...anomalia,
        id: `${anomalia.id}_defeito`,
        id_original: anomalia.id,
        tipo: 'defeito',
        quantidade: defeitos,
        quantidade_classificada: true,
        label_tipo: 'Defeito'
      });
    }
    
    // Linha para arranjos
    if (arranjos > 0) {
      resultado.push({
        ...anomalia,
        id: `${anomalia.id}_arranjo`,
        id_original: anomalia.id,
        tipo: 'arranjo',
        quantidade: arranjos,
        quantidade_classificada: true,
        label_tipo: 'Arranjo'
      });
    }
    
    // Se sobrou quantidade não classificada
    const naoClassificada = anomalia.quantidade - defeitos - arranjos;
    if (naoClassificada > 0) {
      resultado.push({
        ...anomalia,
        id: `${anomalia.id}_pendente`,
        id_original: anomalia.id,
        tipo: anomalia.tipo || 'pendente',
        quantidade: naoClassificada,
        quantidade_classificada: false,
        label_tipo: 'Por Classificar'
      });
    }
    
    return resultado;
  };

  // Obter todas as anomalias (arranjo ou defeito) disponíveis para resgate
  // Filtrar anomalias para resgate - só inclui anomalias de OFs que existem
  const ofsIds = ofs.map(of => of.id);
  
  // Primeiro expandir as anomalias classificadas, depois filtrar
  const anomaliasExpandidas = anomalias.flatMap(a => expandirAnomalias(a));
  
  const anomaliasParaResgate = anomaliasExpandidas.filter(a => 
    a.tipo === 'arranjo' && 
    getQuantidadeDisponivelResgate(a) > 0 &&
    ofsIds.includes(a.of_id)  // Só incluir se a OF ainda existe
  );

  // Estado para classificações de perda dos defeitos selecionados
  const [classificacoesPerda, setClassificacoesPerda] = useState({});
  
  // Estado para classificações de arranjo detalhadas
  // Estrutura: { anomalia_id: [{ tipo: 'costura', quantidade: 2 }, { tipo: 'lavagem', quantidade: 1 }] }
  const [classificacoesArranjo, setClassificacoesArranjo] = useState({});
  
  // Adicionar linha de classificação de arranjo
  const addClassificacaoArranjo = (anomaliaId) => {
    setClassificacoesArranjo(prev => ({
      ...prev,
      [anomaliaId]: [...(prev[anomaliaId] || []), { tipo: '', quantidade: 0 }]
    }));
  };

  // Remover linha de classificação de arranjo
  const removeClassificacaoArranjo = (anomaliaId, index) => {
    setClassificacoesArranjo(prev => ({
      ...prev,
      [anomaliaId]: (prev[anomaliaId] || []).filter((_, i) => i !== index)
    }));
  };

  // Atualizar classificação de arranjo
  const updateClassificacaoArranjo = (anomaliaId, index, field, value) => {
    setClassificacoesArranjo(prev => ({
      ...prev,
      [anomaliaId]: (prev[anomaliaId] || []).map((item, i) => {
        if (i !== index) return item;
        const updated = { ...item, [field]: value };
        // Se estiver a atualizar o tipo, também guardar o nome
        if (field === 'tipo') {
          const tipoInfo = tiposAnomalia.find(t => t.id === value);
          updated.tipo_nome = tipoInfo?.nome || '';
        }
        return updated;
      })
    }));
  };

  // Calcular total de unidades classificadas para uma anomalia de arranjo
  const getTotalClassificadoArranjo = (anomaliaId) => {
    const classificacoes = classificacoesArranjo[anomaliaId] || [];
    return classificacoes.reduce((sum, c) => sum + (parseInt(c.quantidade) || 0), 0);
  };
  
  // Verificar se todos os defeitos selecionados têm classificação de perda
  const defeitosSemClassificacao = Object.entries(anomaliasSelecionadasParaResgate)
    .filter(([id, qtd]) => qtd > 0)
    .filter(([id]) => {
      const anomalia = anomalias.find(a => a.id === id);
      return anomalia?.tipo === 'defeito' && !classificacoesPerda[id];
    });

  // Verificar se todos os arranjos selecionados têm classificação completa
  const arranjosSemClassificacao = Object.entries(anomaliasSelecionadasParaResgate)
    .filter(([id, qtd]) => qtd > 0)
    .filter(([id, qtd]) => {
      const anomalia = anomalias.find(a => a.id === id);
      if (anomalia?.tipo !== 'arranjo') return false;
      const totalClassificado = getTotalClassificadoArranjo(id);
      return totalClassificado < qtd; // Não tem todas as unidades classificadas
    });

  // Agrupar anomalias para resgate por categoria
  const anomaliasResgatePorCategoria = anomaliasParaResgate.reduce((acc, anomalia) => {
    const operacao = operacoes.find(op => op.id === anomalia.operacao_id);
    const categoriaNome = operacao?.categoria || 'Sem Categoria';
    if (!acc[categoriaNome]) {
      acc[categoriaNome] = [];
    }
    acc[categoriaNome].push({
      ...anomalia,
      operacao_nome: operacao?.nome || 'Operação desconhecida',
      of: ofs.find(o => o.id === anomalia.of_id)
    });
    return acc;
  }, {});

  // Criar resgate a partir das anomalias selecionadas
  const handleCriarResgate = async () => {
    const anomaliasParaCriar = Object.entries(anomaliasSelecionadasParaResgate)
      .filter(([_, qtd]) => qtd > 0)
      .map(([anomalia_id, quantidade]) => {
        // Encontrar a anomalia - pode ser uma anomalia expandida com _defeito, _arranjo ou _pendente
        let anomalia = anomaliasExpandidas.find(a => a.id === anomalia_id);
        // O ID original é o que deve ser enviado para o backend
        const id_real = anomalia?.id_original || anomalia_id;
        // Se não encontrar na lista expandida, procurar na original
        if (!anomalia) {
          anomalia = anomalias.find(a => a.id === anomalia_id);
        }
        
        // Buscar classificações por tipo - para DEFEITOS (swap: defeitos têm classificação por tipo)
        let classificacoes = [];
        if (anomalia?.tipo === 'defeito') {
          classificacoes = classificacoesArranjo[anomalia_id] || classificacoesArranjo[id_real] || [];
          classificacoes = classificacoes.filter(c => c.tipo && c.quantidade > 0);
        }
        
        return { 
          anomalia_id: id_real, 
          quantidade: parseInt(quantidade),
          tipo: anomalia?.tipo || 'arranjo',
          // Arranjos já têm os seus tipos classificados — não exigem classificação de perda
          classificacao_perda: null,
          classificacoes_arranjo: classificacoes
        };
      });
    
    if (anomaliasParaCriar.length === 0) {
      toast.error('Selecione pelo menos uma anomalia para resgatar');
      return;
    }
    
    // Verificar se todos os defeitos têm classificação por tipo completa
    const defeitosSemClass = anomaliasParaCriar.filter(a => {
      if (a.tipo !== 'defeito') return false;
      const totalClassif = (a.classificacoes_arranjo || []).reduce((sum, c) => sum + (c.quantidade || 0), 0);
      return totalClassif < a.quantidade;
    });
    if (defeitosSemClass.length > 0) {
      toast.error('Classifique todas as unidades de defeito por tipo');
      return;
    }
    
    setLoading(true);
    try {
      const response = await axios.post(`${API}/resgates?gestor_id=gestor`, {
        anomalias: anomaliasParaCriar,
        nome: nomeResgate.trim() || null, // Nome personalizado ou null para usar padrão
        observacoes: 'Resgate criado via Dashboard de Anomalias'
      });
      
      toast.success(`Resgate ${response.data.numero_resgate} criado com sucesso!`);
      
      // Gerar PDF do resgate
      try {
        const pdfResponse = await axios.get(`${API}/resgates/${response.data.id}/pdf`);
        if (pdfResponse.data.pdf_url) {
          window.open(`${BACKEND_URL}${pdfResponse.data.pdf_url}`, '_blank');
        }
      } catch (e) {
        console.warn('Não foi possível gerar PDF:', e);
      }
      
      // Recarregar dados
      await loadData();
      setAnomaliasSelecionadasParaResgate({});
      setClassificacoesPerda({}); // Limpar classificações de perda
      setClassificacoesArranjo({}); // Limpar classificações de arranjo
      setNomeResgate(''); // Limpar nome
      setOfSelecionadaResgate(''); // Limpar OF selecionada
      setShowCriarResgateModal(false);
    } catch (error) {
      console.error('Erro ao criar resgate:', error);
      toast.error(getErrorMessage(error, 'Erro ao criar resgate'));
    } finally {
      setLoading(false);
    }
  };

  // Calcular total selecionado para resgate
  const totalSelecionadoResgate = Object.values(anomaliasSelecionadasParaResgate)
    .reduce((acc, qtd) => acc + (parseInt(qtd) || 0), 0);

  const handleVerHistorico = (item) => {
    setHistoricoSelecionado(item);
    setShowHistoricoDialog(true);
  };

  const handleVerResgate = async (resgate) => {
    try {
      // Carregar detalhes completos do resgate
      const response = await axios.get(`${API}/resgates/${resgate.id}`);
      setResgateSelecionado(response.data);
      setShowResgateSheet(true);
    } catch (error) {
      console.error('Erro ao carregar resgate:', error);
      toast.error('Erro ao carregar detalhes do resgate');
    }
  };

  // Editar resgate
  const handleEditarResgate = (resgate) => {
    // Por agora, abre o modal de gerir para editar
    // TODO: Implementar modal específico de edição
    handleVerResgate(resgate);
    toast.info('Use o modal de gestão para editar o resgate');
  };
  
  // Eliminar resgate
  const handleEliminarResgate = async (resgate) => {
    if (!window.confirm(`Tem certeza que deseja eliminar o resgate ${resgate.numero_resgate}?\n\nEsta acção não pode ser desfeita.`)) {
      return;
    }
    
    try {
      await axios.delete(`${API}/resgates/${resgate.id}`);
      toast.success('Resgate eliminado com sucesso');
      loadData();
    } catch (error) {
      console.error('Erro ao eliminar resgate:', error);
      toast.error(error.response?.data?.detail || 'Erro ao eliminar resgate');
    }
  };

  const handleMarcarOperacaoFeita = async (operacaoId) => {
    if (!resgateSelecionado) return;
    
    try {
      await axios.post(`${API}/resgates/${resgateSelecionado.id}/marcar-operacao-feita`, {
        operacao_id: operacaoId,
        operador_id: 'gestor'
      });
      
      toast.success('Operação marcada como concluída');
      
      // Recarregar resgate
      const response = await axios.get(`${API}/resgates/${resgateSelecionado.id}`);
      setResgateSelecionado(response.data);
      loadData();
    } catch (error) {
      console.error('Erro ao marcar operação:', error);
      toast.error('Erro ao marcar operação');
    }
  };

  const handleReinserirPecas = async () => {
    if (!resgateSelecionado || reinserirData.quantidade <= 0) {
      toast.error('Indique uma quantidade válida');
      return;
    }
    
    if (!reinserirData.operacao_destino_id) {
      toast.error('Selecione a operação onde as peças serão reinseridas');
      return;
    }
    
    try {
      await axios.post(`${API}/resgates/${resgateSelecionado.id}/reinserir?operador_id=gestor`, {
        resgate_id: resgateSelecionado.id,
        quantidade: reinserirData.quantidade,
        operacao_destino_id: reinserirData.operacao_destino_id,
        observacoes: reinserirData.observacao
      });
      
      // Encontrar nome da operação
      const opIndex = resgateSelecionado.operacoes_falta?.indexOf(reinserirData.operacao_destino_id);
      const opNome = opIndex >= 0 && resgateSelecionado.operacoes_falta_nomes 
        ? resgateSelecionado.operacoes_falta_nomes[opIndex] 
        : 'operação selecionada';
      
      toast.success(`${reinserirData.quantidade} peças reinseridas na ${opNome}`);
      setShowReinserirDialog(false);
      setReinserirData({ quantidade: 0, observacao: '', operacao_destino_id: '' });
      
      // Recarregar resgate
      const response = await axios.get(`${API}/resgates/${resgateSelecionado.id}`);
      setResgateSelecionado(response.data);
      loadData();
    } catch (error) {
      console.error('Erro ao reinserir peças:', error);
      const errorMsg = error.response?.data?.detail;
      toast.error(typeof errorMsg === 'string' ? errorMsg : 'Erro ao reinserir peças');
    }
  };

  const handleDownloadPDF = (resgate) => {
    if (resgate.pdf_url) {
      window.open(`${BACKEND_URL}${resgate.pdf_url}`, '_blank');
    }
  };

  // Funções de Guias de Terceirização
  const loadGuiasResgate = async (resgateId) => {
    try {
      const response = await axios.get(`${API}/resgates/${resgateId}/guias-terceirizacao`);
      setGuiasResgate(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar guias:', error);
    }
  };

  const handleCriarGuia = async () => {
    if (!resgateSelecionado || !novaGuia.numero_guia || novaGuia.quantidade <= 0) {
      toast.error('Preencha o número da guia e quantidade');
      return;
    }

    try {
      const response = await axios.post(
        `${API}/resgates/${resgateSelecionado.id}/guias-terceirizacao?criado_por=gestor`, 
        novaGuia
      );
      toast.success('Guia de terceirização criada');
      setNovaGuia({ numero_guia: '', quantidade: 0, descricao: '', nome_confecao: '' });
      loadGuiasResgate(resgateSelecionado.id);
      
      // Abrir PDF automaticamente
      if (response.data?.guia?.id) {
        const pdfRes = await axios.get(`${API}/guias-terceirizacao/${response.data.guia.id}/pdf`);
        if (pdfRes.data?.pdf_url) {
          window.open(`${BACKEND_URL}${pdfRes.data.pdf_url}`, '_blank');
        }
      }
    } catch (error) {
      toast.error(getErrorMessage(error, 'Erro ao criar guia'));
    }
  };

  const handleAbrirEditGuia = (guia) => {
    setGuiaSelecionada(guia);
    setEditGuiaData({
      entregas: guia.entregas?.length > 0 ? guia.entregas : [
        { data: '', quantidade_recebida: 0, observacoes: '' },
        { data: '', quantidade_recebida: 0, observacoes: '' },
        { data: '', quantidade_recebida: 0, observacoes: '' }
      ],
      pecas_com_defeito: guia.pecas_com_defeito || 0,
      observacoes_finais: guia.observacoes_finais || ''
    });
    setShowEditGuia(true);
  };

  const handleSaveGuia = async () => {
    if (!guiaSelecionada) return;

    try {
      await axios.put(`${API}/guias-terceirizacao/${guiaSelecionada.id}`, editGuiaData);
      toast.success('Guia actualizada');
      setShowEditGuia(false);
      loadGuiasResgate(resgateSelecionado.id);
      
      // Gerar novo PDF
      const pdfRes = await axios.get(`${API}/guias-terceirizacao/${guiaSelecionada.id}/pdf`);
      if (pdfRes.data?.pdf_url) {
        toast.success('PDF actualizado');
      }
    } catch (error) {
      toast.error(getErrorMessage(error, 'Erro ao actualizar guia'));
    }
  };

  const handleDownloadGuiaPDF = async (guiaId) => {
    try {
      const response = await axios.get(`${API}/guias-terceirizacao/${guiaId}/pdf`);
      if (response.data?.pdf_url) {
        window.open(`${BACKEND_URL}${response.data.pdf_url}`, '_blank');
      }
    } catch (error) {
      toast.error('Erro ao gerar PDF');
    }
  };

  const handleEliminarGuia = async () => {
    if (!guiaParaEliminar) return;
    try {
      const response = await axios.delete(`${API}/guias-terceirizacao/${guiaParaEliminar.id}?eliminado_por=gestor`);
      toast.success(response.data?.message || 'Guia eliminada com sucesso');
      setShowDeleteGuiaConfirm(false);
      setGuiaParaEliminar(null);
      
      // Recarregar guias do resgate
      if (resgateSelecionado) {
        const guiasRes = await axios.get(`${API}/resgates/${resgateSelecionado.id}/guias-terceirizacao`);
        setGuiasResgate(guiasRes.data || []);
      }
      loadData();
    } catch (error) {
      console.error('Erro ao eliminar guia:', error);
      toast.error(getErrorMessage(error, 'Erro ao eliminar guia'));
    }
  };

  const handleEditResgate = () => {
    if (!resgateSelecionado) return;
    setEditResgateData({
      observacoes: resgateSelecionado.observacoes || '',
      status: resgateSelecionado.status || 'em_arranjo',
      prioridade: resgateSelecionado.prioridade || 2
    });
    setShowEditResgateDialog(true);
  };

  const handleSaveResgate = async () => {
    if (!resgateSelecionado) return;
    try {
      await axios.put(`${API}/resgates/${resgateSelecionado.id}`, editResgateData);
      toast.success('Resgate atualizado com sucesso');
      setShowEditResgateDialog(false);
      
      // Recarregar resgate
      const response = await axios.get(`${API}/resgates/${resgateSelecionado.id}`);
      setResgateSelecionado(response.data);
      loadData();
    } catch (error) {
      console.error('Erro ao atualizar resgate:', error);
      toast.error('Erro ao atualizar resgate');
    }
  };

  const handleDeleteResgate = async () => {
    if (!resgateSelecionado) return;
    try {
      await axios.delete(`${API}/resgates/${resgateSelecionado.id}`);
      toast.success('Resgate apagado com sucesso');
      setShowDeleteConfirm(false);
      setShowResgateSheet(false);
      setResgateSelecionado(null);
      loadData();
    } catch (error) {
      console.error('Erro ao apagar resgate:', error);
      const errorMsg = error.response?.data?.detail;
      toast.error(typeof errorMsg === 'string' ? errorMsg : 'Erro ao apagar resgate');
    }
  };

  const handleVerAnomaliaDetail = (anomalia) => {
    setAnomaliaSelecionada(anomalia);
    setShowAnomaliaDetail(true);
  };

  // Abrir dialog de editar anomalia
  const handleEditarAnomalia = (anomalia) => {
    setAnomaliaParaAcao(anomalia);
    // Inicializar com a quantidade distribuída se já existir, senão toda na quantidade original
    const qtdDefeitos = anomalia.quantidade_defeitos || 0;
    const qtdArranjos = anomalia.quantidade_arranjos || 0;
    const qtdTotal = anomalia.quantidade || 0;
    
    setEditAnomaliaData({
      quantidade: qtdTotal,
      quantidade_defeitos: qtdDefeitos,
      quantidade_arranjos: qtdArranjos,
      // Se não houver distribuição, colocar tudo no tipo original
      quantidade_nao_classificada: qtdTotal - qtdDefeitos - qtdArranjos,
      observacoes: anomalia.observacoes || '',
      razao: anomalia.razao || ''
    });
    setShowEditAnomaliaDialog(true);
  };

  // Guardar edição de anomalia
  const handleSaveEditAnomalia = async () => {
    if (!anomaliaParaAcao) return;
    
    // Validar que a soma das classificações não excede a quantidade total
    const total = editAnomaliaData.quantidade;
    const defeitos = editAnomaliaData.quantidade_defeitos || 0;
    const arranjos = editAnomaliaData.quantidade_arranjos || 0;
    
    if (defeitos + arranjos > total) {
      toast.error('A soma de Defeitos e Arranjos não pode exceder a quantidade total');
      return;
    }
    
    setLoading(true);
    try {
      await axios.put(`${API}/anomalias-producao/${anomaliaParaAcao.id}`, {
        quantidade: editAnomaliaData.quantidade,
        quantidade_defeitos: defeitos,
        quantidade_arranjos: arranjos,
        observacoes: editAnomaliaData.observacoes
      });
      toast.success('Anomalia atualizada com sucesso!');
      setShowEditAnomaliaDialog(false);
      setAnomaliaParaAcao(null);
      loadData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Erro ao atualizar anomalia'));
    }
    setLoading(false);
  };

  // Apagar anomalia
  const handleDeleteAnomalia = async () => {
    if (!anomaliaParaAcao) return;
    setLoading(true);
    try {
      await axios.delete(`${API}/anomalias-producao/${anomaliaParaAcao.id}`);
      toast.success('Anomalia eliminada com sucesso!');
      setShowDeleteAnomaliaConfirm(false);
      setAnomaliaParaAcao(null);
      loadData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Erro ao eliminar anomalia'));
    }
    setLoading(false);
  };

  // Arquivar anomalia
  const handleArquivarAnomalia = async () => {
    if (!anomaliaParaAcao) return;
    setLoading(true);
    try {
      await axios.patch(`${API}/anomalias-producao/${anomaliaParaAcao.id}/arquivar`);
      toast.success('Anomalia arquivada com sucesso!');
      setShowArquivarAnomaliaConfirm(false);
      setAnomaliaParaAcao(null);
      loadData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Erro ao arquivar anomalia'));
    }
    setLoading(false);
  };

  // Desarquivar anomalia
  const handleDesarquivarAnomalia = async (anomalia) => {
    setLoading(true);
    try {
      await axios.patch(`${API}/anomalias-producao/${anomalia.id}/desarquivar`);
      toast.success('Anomalia restaurada com sucesso!');
      loadData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Erro ao restaurar anomalia'));
    }
    setLoading(false);
  };

  // Classificar anomalia pendente como arranjo ou defeito
  const handleClassificarAnomalia = async (anomaliaId, novoTipo) => {
    setLoading(true);
    try {
      await axios.patch(`${API}/anomalias-producao/${anomaliaId}/classificar`, {
        tipo: novoTipo
      });
      toast.success(`Anomalia classificada como ${novoTipo === 'arranjo' ? 'Arranjo' : 'Defeito'}!`);
      loadData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Erro ao classificar anomalia'));
    }
    setLoading(false);
  };

  // Ordenar e filtrar resgates (memoizado para evitar trabalho redundante em cada render)
  const resgatesFiltrados = useMemo(() => resgates.filter(r => {
    // Filtro de status
    if (resgateFiltroStatus !== 'todos' && r.status !== resgateFiltroStatus) return false;
    // Filtro de pesquisa
    if (resgateFiltroPesquisa) {
      const pesquisa = resgateFiltroPesquisa.toLowerCase();
      const of = ofs.find(o => o.id === r.of_id);
      const matchNumero = r.numero_resgate?.toLowerCase().includes(pesquisa);
      const matchOF = of?.numero_of?.toLowerCase().includes(pesquisa);
      const matchCliente = of?.cliente?.toLowerCase().includes(pesquisa);
      if (!matchNumero && !matchOF && !matchCliente) return false;
    }
    return true;
  }), [resgates, resgateFiltroStatus, resgateFiltroPesquisa, ofs]);
  
  const resgatesOrdenados = useMemo(() => [...resgatesFiltrados].sort((a, b) => {
    switch (resgateOrdem) {
      case 'data_desc':
        return new Date(b.criado_em) - new Date(a.criado_em);
      case 'data_asc':
        return new Date(a.criado_em) - new Date(b.criado_em);
      case 'qtd_desc':
        return (b.quantidade_total || 0) - (a.quantidade_total || 0);
      case 'qtd_asc':
        return (a.quantidade_total || 0) - (b.quantidade_total || 0);
      case 'status': {
        const statusOrder = { 'em_arranjo': 0, 'parcial': 1, 'concluido': 2 };
        return (statusOrder[a.status] || 0) - (statusOrder[b.status] || 0);
      }
      case 'prioridade':
        return (a.prioridade || 3) - (b.prioridade || 3);
      default:
        return 0;
    }
  }), [resgatesFiltrados, resgateOrdem]);

  // Filtrar anomalias por tipo (memoizado)
  const anomaliasFiltradas = useMemo(() => anomalias.filter(a => {
    if (!mostrarArquivadas && a.status === 'arquivado') return false;
    if (tipoFiltroAnomalia === 'todos') return true;
    return a.tipo === tipoFiltroAnomalia;
  }), [anomalias, mostrarArquivadas, tipoFiltroAnomalia]);
  
  // Contar arquivadas para mostrar no toggle (memoizado)
  const totalArquivadas = useMemo(() => anomalias.filter(a => a.status === 'arquivado').length, [anomalias]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'pendente': return 'bg-yellow-100 text-yellow-700';
      case 'em_arranjo': return 'bg-blue-100 text-blue-700';
      case 'recuperado': return 'bg-green-100 text-green-700';
      case 'descartado': return 'bg-red-100 text-red-700';
      case 'arquivado': return 'bg-stone-200 text-stone-600';
      default: return 'bg-stone-100 text-stone-700';
    }
  };

  return (
    <GestorLayout>
      <div className="p-6 space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-heading text-navy">Gestão de Anomalias</h1>
            <p className="text-stone-500">Gestão centralizada de defeitos e arranjos</p>
          </div>
          <div className="flex items-center gap-2">
            {activeTab === 'dashboard' && (
              <Button 
                onClick={() => setShowAdicionarAnomaliaModal(true)}
                variant="outline"
                className="border-amber-200 text-amber-700 hover:bg-amber-50"
                data-testid="adicionar-anomalia-btn"
              >
                <AlertTriangle className="h-4 w-4 mr-2" />
                Adicionar Anomalia
              </Button>
            )}
            {activeTab === 'tipos' && (
              <Button onClick={() => { resetTipoForm(); setShowTipoDialog(true); }}>
                <AlertTriangle className="h-4 w-4 mr-2" />
                Novo Tipo
              </Button>
            )}
            <Button onClick={loadData} disabled={loading} variant="outline">
              <RefreshCw className={`h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
              Actualizar
            </Button>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex gap-4 border-b border-stone-200 flex-wrap">
          <button
            onClick={() => setActiveTab('dashboard')}
            className={`px-4 py-3 font-medium transition-colors flex items-center gap-2 border-b-2 ${
              activeTab === 'dashboard'
                ? 'text-primary border-primary'
                : 'text-stone-500 hover:text-stone-700 border-transparent'
            }`}
            data-testid="tab-dashboard"
          >
            <Activity className="h-4 w-4" />
            Dashboard
          </button>
          <button
            onClick={() => setActiveTab('arranjos')}
            className={`px-4 py-3 font-medium transition-colors flex items-center gap-2 border-b-2 ${
              activeTab === 'arranjos'
                ? 'text-amber-700 border-amber-700'
                : 'text-stone-500 hover:text-stone-700 border-transparent'
            }`}
            data-testid="tab-arranjos"
          >
            <Wrench className="h-4 w-4" />
            Arranjos
          </button>
          <button
            onClick={() => setActiveTab('defeitos')}
            className={`px-4 py-3 font-medium transition-colors flex items-center gap-2 border-b-2 ${
              activeTab === 'defeitos'
                ? 'text-red-700 border-red-700'
                : 'text-stone-500 hover:text-stone-700 border-transparent'
            }`}
            data-testid="tab-defeitos"
          >
            <X className="h-4 w-4" />
            Defeitos
          </button>
          <button
            onClick={() => setActiveTab('terceirizacao')}
            className={`px-4 py-3 font-medium transition-colors flex items-center gap-2 border-b-2 ${
              activeTab === 'terceirizacao'
                ? 'text-blue-700 border-blue-700'
                : 'text-stone-500 hover:text-stone-700 border-transparent'
            }`}
            data-testid="tab-terceirizacao"
          >
            <Truck className="h-4 w-4" />
            Resgates/Terceirizações
          </button>
          <button
            onClick={() => setActiveTab('tipos')}
            className={`px-4 py-3 font-medium transition-colors flex items-center gap-2 border-b-2 ml-auto ${
              activeTab === 'tipos'
                ? 'text-primary border-primary'
                : 'text-stone-500 hover:text-stone-700 border-transparent'
            }`}
            data-testid="tab-tipos-anomalias"
          >
            <FileText className="h-4 w-4" />
            Tipos de Anomalias ({tiposAnomalia.length})
          </button>
        </div>

        {/* Tab: Dashboard — Nova Grelha (Fase 2) */}
        {activeTab === 'dashboard' && (
          <AnomaliasGrelha />
        )}

        {/* Tab: Arranjos — filtro predefinido qtd_arranjo > 0 */}
        {activeTab === 'arranjos' && (
          <AnomaliasGrelha filtroFixo="arranjos" />
        )}

        {/* Tab: Defeitos — filtro predefinido qtd_defeito > 0 */}
        {activeTab === 'defeitos' && (
          <AnomaliasGrelha filtroFixo="defeitos" />
        )}

        {(activeTab === 'resgates' || activeTab === 'terceirizacao') && (
          <div className="space-y-6">
            {/* Botão Nova Terceirização */}
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-lg font-bold text-stone-800">
                  {activeTab === 'terceirizacao' ? 'Terceirização de Peças' : 'Resgates e Arranjos'}
                </h2>
                <p className="text-xs text-stone-500">Crie uma nova terceirização a partir das peças classificadas como Arranjo.</p>
              </div>
              <Button
                onClick={() => setShowCriarResgateModal(true)}
                className="bg-red-600 hover:bg-red-700 text-white"
                data-testid="btn-nova-terceirizacao"
              >
                <Plus className="h-4 w-4 mr-1" />
                Nova Terceirização
              </Button>
            </div>
            {/* Estatísticas dos Resgates */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <Card className="p-4 bg-blue-50 border-blue-200">
                <p className="text-xs text-blue-600 font-medium mb-1">Em Arranjo</p>
                <p className="text-2xl font-bold text-blue-700">
                  {resgates.filter(r => r.status === 'em_arranjo').length}
                </p>
              </Card>
              <Card className="p-4 bg-amber-50 border-amber-200">
                <p className="text-xs text-amber-600 font-medium mb-1">Parciais</p>
                <p className="text-2xl font-bold text-amber-700">
                  {resgates.filter(r => r.status === 'parcial').length}
                </p>
              </Card>
              <Card className="p-4 bg-green-50 border-green-200">
                <p className="text-xs text-green-600 font-medium mb-1">Concluídos</p>
                <p className="text-2xl font-bold text-green-700">
                  {resgates.filter(r => r.status === 'concluido').length}
                </p>
              </Card>
              <Card className="p-4 bg-red-50 border-red-200">
                <p className="text-xs text-red-600 font-medium mb-1">Alta Prioridade</p>
                <p className="text-2xl font-bold text-red-700">
                  {resgates.filter(r => r.prioridade === 1).length}
                </p>
              </Card>
            </div>
            
            {/* Filtros e Ordenação */}
            <Card className="p-4">
              <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
                {/* Pesquisa */}
                <div className="flex-1 relative">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
                  <input
                    type="text"
                    placeholder="Pesquisar por OF, cliente ou número do resgate..."
                    value={resgateFiltroPesquisa}
                    onChange={(e) => setResgateFiltroPesquisa(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-stone-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
                  />
                </div>
                
                {/* Filtro de Status */}
                <div className="flex items-center gap-2">
                  <Filter className="h-4 w-4 text-stone-400" />
                  <select
                    value={resgateFiltroStatus}
                    onChange={(e) => setResgateFiltroStatus(e.target.value)}
                    className="text-sm border border-stone-200 rounded-lg px-3 py-2"
                  >
                    <option value="todos">Todos os Status</option>
                    <option value="em_arranjo">Em Arranjo</option>
                    <option value="parcial">Parciais</option>
                    <option value="concluido">Concluídos</option>
                  </select>
                </div>
                
                {/* Ordenação */}
                <div className="flex items-center gap-2">
                  <ArrowUpDown className="h-4 w-4 text-stone-400" />
                  <select
                    value={resgateOrdem}
                    onChange={(e) => setResgateOrdem(e.target.value)}
                    className="text-sm border border-stone-200 rounded-lg px-3 py-2"
                  >
                    <option value="data_desc">Mais recentes</option>
                    <option value="data_asc">Mais antigos</option>
                    <option value="qtd_desc">Maior quantidade</option>
                    <option value="qtd_asc">Menor quantidade</option>
                    <option value="status">Por status</option>
                    <option value="prioridade">Por prioridade</option>
                  </select>
                </div>

                {/* Toggle Vista Grelha / Lista */}
                <div className="flex items-center rounded-lg border border-stone-200 overflow-hidden ml-auto" data-testid="vista-resgates-toggle">
                  <button
                    type="button"
                    onClick={() => setVistaResgates('grelha')}
                    className={`px-3 py-2 text-xs font-medium flex items-center gap-1.5 transition ${vistaResgates === 'grelha' ? 'bg-stone-800 text-white' : 'text-stone-600 hover:bg-stone-50'}`}
                    data-testid="vista-grelha"
                    title="Vista em grelha (cards)"
                  >
                    <LayoutGrid className="h-3.5 w-3.5" /> Grelha
                  </button>
                  <button
                    type="button"
                    onClick={() => setVistaResgates('lista')}
                    className={`px-3 py-2 text-xs font-medium flex items-center gap-1.5 transition ${vistaResgates === 'lista' ? 'bg-stone-800 text-white' : 'text-stone-600 hover:bg-stone-50'}`}
                    data-testid="vista-lista"
                    title="Vista em lista (tabela)"
                  >
                    <List className="h-3.5 w-3.5" /> Lista
                  </button>
                </div>
              </div>
              
              {/* Contador de resultados */}
              <div className="mt-3 text-sm text-stone-500">
                Mostrando {resgatesOrdenados.length} de {resgates.length} resgates
                {resgateFiltroPesquisa && ` • Pesquisa: "${resgateFiltroPesquisa}"`}
                {resgateFiltroStatus !== 'todos' && ` • Status: ${resgateFiltroStatus === 'em_arranjo' ? 'Em Arranjo' : resgateFiltroStatus === 'parcial' ? 'Parciais' : 'Concluídos'}`}
              </div>
            </Card>
            
            {/* Lista de Resgates */}
            {resgatesOrdenados.length === 0 ? (
              <Card className="p-12 text-center">
                <Wrench className="h-16 w-16 mx-auto text-stone-300 mb-4" />
                {resgates.length === 0 ? (
                  <>
                    <p className="text-xl font-medium text-stone-700 mb-2">Nenhum resgate</p>
                    <p className="text-stone-500">
                      Ainda não existem resgates criados. Crie um resgate a partir das anomalias no Dashboard.
                    </p>
                  </>
                ) : (
                  <>
                    <p className="text-xl font-medium text-stone-700 mb-2">Nenhum resultado</p>
                    <p className="text-stone-500">
                      Nenhum resgate corresponde aos filtros selecionados.
                    </p>
                    <Button 
                      variant="outline" 
                      className="mt-4"
                      onClick={() => {
                        setResgateFiltroPesquisa('');
                        setResgateFiltroStatus('todos');
                      }}
                    >
                      Limpar filtros
                    </Button>
                  </>
                )}
              </Card>
            ) : vistaResgates === 'lista' ? (
              <Card className="overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full text-sm" data-testid="resgates-tabela-lista">
                    <thead>
                      <tr className="text-left text-stone-500 border-b bg-stone-50">
                        <th className="py-2 px-3 font-semibold">N.º</th>
                        <th className="py-2 px-3 font-semibold">Status</th>
                        <th className="py-2 px-3 font-semibold">OF</th>
                        <th className="py-2 px-3 font-semibold">Modelo</th>
                        <th className="py-2 px-3 font-semibold">Marca</th>
                        <th className="py-2 px-3 font-semibold">Criado em</th>
                        <th className="py-2 px-3 font-semibold">Por</th>
                        <th className="py-2 px-3 text-right font-semibold">Total</th>
                        <th className="py-2 px-3 text-right font-semibold">Em Arranjo</th>
                        <th className="py-2 px-3 text-right font-semibold">Devolvidas</th>
                        <th className="py-2 px-3 text-right font-semibold">%</th>
                        <th className="py-2 px-3 text-center font-semibold">Acções</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resgatesOrdenados.map((resgate) => {
                        const of = ofs.find(o => o.id === resgate.of_id);
                        const qtdTotal = resgate.quantidade_total || 0;
                        const qtdRecuperada = resgate.quantidade_recuperada || 0;
                        const qtdEmGuias = (resgate.guias_terceirizacao || []).filter(g => g.status !== 'devolvido').reduce((acc, g) => acc + (g.quantidade || 0), 0);
                        const qtdDevolvida = (resgate.guias_terceirizacao || []).reduce((acc, g) => acc + (g.total_recebido || 0), 0);
                        const qtdResgatada = qtdRecuperada + qtdDevolvida;
                        const progresso = qtdTotal > 0 ? Math.round((qtdResgatada / qtdTotal) * 100) : 0;
                        let dataCriacao = '—';
                        try {
                          const rawDt = resgate.criado_em || resgate.data_criacao;
                          const dt = rawDt ? new Date(rawDt) : null;
                          if (dt && !isNaN(dt)) {
                            dataCriacao = dt.toLocaleDateString('pt-PT');
                          }
                        } catch (_) { /* fallback */ }
                        const criadoPor = resgate.criado_por_nome || (resgate.criado_por === 'gestor' ? 'Gestor' : (resgate.criado_por || '—'));
                        const statusBadge = resgate.status === 'em_arranjo' ? 'bg-blue-100 text-blue-700' :
                          resgate.status === 'concluido' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700';
                        const statusLabel = resgate.status === 'em_arranjo' ? 'Em Arranjo' :
                          resgate.status === 'concluido' ? 'Concluído' : 'Parcial';
                        return (
                          <tr key={resgate.id} className="border-b last:border-0 hover:bg-stone-50" data-testid={`resgate-row-${resgate.id}`}>
                            <td className="py-2 px-3 font-semibold text-stone-800">{resgate.numero_resgate}</td>
                            <td className="py-2 px-3">
                              <span className={`text-[11px] px-2 py-0.5 rounded font-medium ${statusBadge}`}>{statusLabel}</span>
                              {resgate.prioridade === 1 && <span className="ml-1 text-[10px] bg-red-100 text-red-700 px-1.5 rounded font-bold">!</span>}
                            </td>
                            <td className="py-2 px-3 font-mono text-xs text-stone-600">{of?.numero_of || resgate.of_numero || '—'}</td>
                            <td className="py-2 px-3 text-xs text-stone-600 truncate max-w-[120px]" title={of?.modelo || of?.artigo}>{of?.modelo || of?.artigo || '—'}</td>
                            <td className="py-2 px-3 text-xs text-stone-600 truncate max-w-[120px]" title={of?.marca || of?.cliente}>{of?.marca || of?.cliente || '—'}</td>
                            <td className="py-2 px-3 font-mono text-xs text-stone-500">{dataCriacao}</td>
                            <td className="py-2 px-3 text-xs">{criadoPor}</td>
                            <td className="py-2 px-3 text-right font-semibold text-orange-700">{qtdTotal}</td>
                            <td className="py-2 px-3 text-right text-blue-700">{qtdEmGuias}</td>
                            <td className="py-2 px-3 text-right text-green-700">{qtdResgatada}</td>
                            <td className="py-2 px-3 text-right text-stone-600 font-medium">{progresso}%</td>
                            <td className="py-2 px-3">
                              <div className="flex items-center justify-center gap-1">
                                <Button
                                  size="sm"
                                  className="h-7 px-2 bg-orange-600 hover:bg-orange-700 text-white"
                                  onClick={() => {
                                    setResgateSelecionado(resgate);
                                    setShowGuiaTerceirizacao(true);
                                    loadGuiasResgate(resgate.id);
                                  }}
                                  title="Terceirizar"
                                  data-testid={`btn-row-terceirizar-${resgate.id}`}
                                >
                                  <Truck className="h-3.5 w-3.5" />
                                </Button>
                                <button
                                  onClick={() => handleEliminarResgate(resgate)}
                                  className="text-stone-400 hover:text-red-600 p-1"
                                  title="Eliminar"
                                  data-testid={`btn-row-eliminar-${resgate.id}`}
                                >
                                  <Trash2 className="h-3.5 w-3.5" />
                                </button>
                                {resgate.pdf_url && (
                                  <button
                                    onClick={() => handleDownloadPDF(resgate)}
                                    className="text-stone-400 hover:text-blue-600 p-1"
                                    title="Download PDF"
                                    data-testid={`btn-row-pdf-${resgate.id}`}
                                  >
                                    <Download className="h-3.5 w-3.5" />
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </Card>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {resgatesOrdenados.map((resgate) => {
                  const of = ofs.find(o => o.id === resgate.of_id);
                  // Cálculo de quantidades resgatadas (recuperadas + em guias activas)
                  const qtdTotal = resgate.quantidade_total || 0;
                  const qtdRecuperada = resgate.quantidade_recuperada || 0;
                  const qtdEmGuias = (resgate.guias_terceirizacao || []).filter(g => g.status !== 'devolvido').reduce((acc, g) => acc + (g.quantidade || 0), 0);
                  const qtdDevolvida = (resgate.guias_terceirizacao || []).reduce((acc, g) => acc + (g.total_recebido || 0), 0);
                  const qtdResgatada = qtdRecuperada + qtdDevolvida;
                  const progresso = qtdTotal > 0 ? Math.round((qtdResgatada / qtdTotal) * 100) : 0;
                  // Data de criação formatada
                  let dataCriacao = '—';
                  try {
                    const rawDt = resgate.criado_em || resgate.data_criacao;
                    const dt = rawDt ? new Date(rawDt) : null;
                    if (dt && !isNaN(dt)) {
                      dataCriacao = dt.toLocaleDateString('pt-PT') + ' ' + dt.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
                    }
                  } catch (_) { /* fallback */ }
                  // Resolver criador
                  const criadoPor = resgate.criado_por_nome || (resgate.criado_por === 'gestor' ? 'Gestor' : (resgate.criado_por || '—'));
                  
                  return (
                    <Card key={resgate.id} className={`p-4 hover:shadow-md transition-shadow ${
                      resgate.status === 'concluido' ? 'bg-green-50/50 border-green-200' : 
                      resgate.status === 'em_arranjo' ? 'bg-blue-50/50 border-blue-200' : 
                      'bg-amber-50/50 border-amber-200'
                    } ${
                      resgate.prioridade === 1 ? 'border-l-4 border-l-red-500' :
                      resgate.prioridade === 2 ? 'border-l-4 border-l-amber-500' : ''
                    }`} data-testid={`resgate-card-${resgate.id}`}>
                      <div className="flex items-center justify-between mb-2">
                        <span className="font-semibold text-stone-800 text-base">{resgate.numero_resgate}</span>
                        <div className="flex items-center gap-1">
                          {resgate.prioridade === 1 && <span className="text-xs bg-red-100 text-red-700 px-1.5 rounded font-semibold">Alta</span>}
                          <span className={`text-xs px-2 py-0.5 rounded font-medium ${
                            resgate.status === 'em_arranjo' ? 'bg-blue-100 text-blue-700' : 
                            resgate.status === 'concluido' ? 'bg-green-100 text-green-700' :
                            'bg-amber-100 text-amber-700'
                          }`}>
                            {resgate.status === 'em_arranjo' ? 'Em Arranjo' : 
                             resgate.status === 'concluido' ? 'Concluído' : 'Parcial'}
                          </span>
                        </div>
                      </div>

                      {/* Bloco de info OF / Modelo / Marca / Data / Criador */}
                      <div className="grid grid-cols-2 gap-x-3 gap-y-1 text-xs mb-3 p-2 rounded-md bg-white/60 border border-stone-100">
                        <div>
                          <span className="text-stone-400 uppercase text-[10px] font-semibold">OF</span>
                          <p className="text-stone-700 font-medium truncate">{of?.numero_of || resgate.of_numero || '—'}</p>
                        </div>
                        <div>
                          <span className="text-stone-400 uppercase text-[10px] font-semibold">Modelo</span>
                          <p className="text-stone-700 font-medium truncate">{of?.modelo || of?.artigo || '—'}</p>
                        </div>
                        <div>
                          <span className="text-stone-400 uppercase text-[10px] font-semibold">Marca</span>
                          <p className="text-stone-700 font-medium truncate">{of?.marca || of?.cliente || '—'}</p>
                        </div>
                        <div>
                          <span className="text-stone-400 uppercase text-[10px] font-semibold">Criado em</span>
                          <p className="text-stone-700 font-medium truncate">{dataCriacao}</p>
                        </div>
                        <div className="col-span-2">
                          <span className="text-stone-400 uppercase text-[10px] font-semibold">Criado por</span>
                          <p className="text-stone-700 font-medium truncate">{criadoPor}</p>
                        </div>
                      </div>

                      {/* Quantidades — em vez de operações (não fazem sentido aqui) */}
                      <div className="grid grid-cols-3 gap-2 text-xs mb-3" data-testid={`resgate-quantidades-${resgate.id}`}>
                        <div className="p-2 rounded-md bg-orange-50 border border-orange-200 text-center">
                          <p className="text-[10px] uppercase text-orange-600 font-bold">Total</p>
                          <p className="text-base font-bold text-orange-700">{qtdTotal}</p>
                        </div>
                        <div className="p-2 rounded-md bg-blue-50 border border-blue-200 text-center">
                          <p className="text-[10px] uppercase text-blue-600 font-bold">Em Arranjo</p>
                          <p className="text-base font-bold text-blue-700">{qtdEmGuias}</p>
                        </div>
                        <div className="p-2 rounded-md bg-green-50 border border-green-200 text-center">
                          <p className="text-[10px] uppercase text-green-600 font-bold">Devolvidas</p>
                          <p className="text-base font-bold text-green-700">{qtdResgatada}</p>
                        </div>
                      </div>
                      
                      {/* Barra de Progresso (peças resgatadas / total) */}
                      <div className="mb-3">
                        <div className="h-2 bg-stone-200 rounded-full overflow-hidden">
                          <div 
                            className={`h-full rounded-full transition-all ${
                              resgate.status === 'concluido' ? 'bg-green-500' : 'bg-blue-500'
                            }`}
                            style={{ width: `${progresso}%` }}
                          />
                        </div>
                        <p className="text-xs text-stone-500 mt-1 text-right font-medium">
                          {qtdResgatada}/{qtdTotal} peças resgatadas ({progresso}%)
                        </p>
                      </div>
                      
                      {/* Acções */}
                      <div className="flex items-center gap-1 flex-wrap" data-testid={`resgate-actions-${resgate.id}`}>
                        <Button 
                          size="sm" 
                          className="bg-orange-600 hover:bg-orange-700 text-white"
                          onClick={() => {
                            setResgateSelecionado(resgate);
                            setShowGuiaTerceirizacao(true);
                            loadGuiasResgate(resgate.id);
                          }}
                          data-testid={`btn-terceirizar-${resgate.id}`}
                        >
                          <Truck className="h-4 w-4 mr-1.5" />
                          Terceirizar
                        </Button>
                        <Button 
                          size="sm" 
                          variant="ghost"
                          className="text-stone-500 hover:text-red-600 p-2"
                          onClick={() => handleEliminarResgate(resgate)}
                          title="Eliminar"
                          data-testid={`btn-eliminar-${resgate.id}`}
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                        {resgate.pdf_url && (
                          <Button 
                            size="sm" 
                            variant="ghost"
                            className="text-stone-500 hover:text-blue-600 p-2"
                            onClick={() => handleDownloadPDF(resgate)}
                            title="Download PDF"
                            data-testid={`btn-pdf-${resgate.id}`}
                          >
                            <Download className="h-4 w-4" />
                          </Button>
                        )}
                      </div>
                    </Card>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* Tab: Tipos de Anomalias */}
        {activeTab === 'tipos' && (
          <div className="space-y-6">
            {loading ? (
              <div className="flex items-center justify-center py-12">
                <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full"></div>
              </div>
            ) : tiposAnomalia.length === 0 ? (
              <Card className="p-12 text-center">
                <FileText className="h-16 w-16 mx-auto text-stone-300 mb-4" />
                <p className="text-xl font-medium text-stone-700 mb-2">Nenhum tipo configurado</p>
                <p className="text-stone-500 mb-6">
                  Crie tipos de anomalias para que os operadores possam reportar problemas durante a produção
                </p>
                <Button onClick={() => setShowTipoDialog(true)}>
                  <AlertTriangle className="h-4 w-4 mr-2" />
                  Criar Primeiro Tipo
                </Button>
              </Card>
            ) : (
              <div className="grid gap-8 md:grid-cols-2">
                {/* Defeitos */}
                <div>
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-lg bg-red-100 flex items-center justify-center">
                      <XCircle className="h-4 w-4 text-red-600" />
                    </div>
                    <div>
                      <h2 className="font-semibold text-stone-900">Defeitos (Perda Total)</h2>
                      <p className="text-sm text-stone-500">Peças que não podem ser recuperadas</p>
                    </div>
                  </div>
                  
                  {tiposDefeito.length === 0 ? (
                    <Card className="p-6 text-center border-dashed">
                      <p className="text-stone-400">Nenhum tipo de defeito configurado</p>
                    </Card>
                  ) : (
                    <div className="space-y-3">
                      {tiposDefeito.sort((a, b) => (a.ordem || 0) - (b.ordem || 0)).map((tipo) => (
                        <Card 
                          key={tipo.id} 
                          className={`p-4 hover:shadow-md transition-all cursor-grab active:cursor-grabbing ${dragOverTipo === tipo.id ? 'border-2 border-blue-500 bg-blue-50' : ''}`}
                          draggable
                          onDragStart={(e) => handleTipoDragStart(e, tipo)}
                          onDragOver={(e) => handleTipoDragOver(e, tipo)}
                          onDragLeave={handleTipoDragLeave}
                          onDrop={(e) => handleTipoDrop(e, tipo)}
                          onDragEnd={handleTipoDragEnd}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <GripVertical className="h-5 w-5 text-stone-400" />
                              <div 
                                className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold text-sm"
                                style={{ backgroundColor: tipo.cor }}
                              >
                                {tipo.codigo || tipo.nome?.charAt(0)}
                              </div>
                              <div>
                                <p className="font-medium text-stone-900">{tipo.nome}</p>
                                {tipo.descricao && (
                                  <p className="text-sm text-stone-500">{tipo.descricao}</p>
                                )}
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <Button variant="ghost" size="sm" onClick={() => openEditTipo(tipo)}>
                                <Edit className="h-4 w-4" />
                              </Button>
                              <Button 
                                variant="ghost" 
                                size="sm"
                                className="text-red-500 hover:text-red-600 hover:bg-red-50"
                                onClick={() => handleDeleteTipo(tipo.id)}
                              >
                                <Trash2 className="h-4 w-4" />
                              </Button>
                            </div>
                          </div>
                        </Card>
                      ))}
                    </div>
                  )}
                </div>

                {/* Para Arranjo */}
                <div>
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center">
                      <Wrench className="h-4 w-4 text-amber-600" />
                    </div>
                    <div>
                      <h2 className="font-semibold text-stone-900">Para Arranjo</h2>
                      <p className="text-sm text-stone-500">Peças que podem ser recuperadas</p>
                    </div>
                  </div>
                  
                  {tiposArranjo.length === 0 ? (
                    <Card className="p-6 text-center border-dashed">
                      <p className="text-stone-400">Nenhum tipo de arranjo configurado</p>
                    </Card>
                  ) : (
                    <div className="space-y-3">
                      {tiposArranjo.sort((a, b) => (a.ordem || 0) - (b.ordem || 0)).map((tipo) => (
                        <Card 
                          key={tipo.id} 
                          className={`p-4 hover:shadow-md transition-all cursor-grab active:cursor-grabbing ${dragOverTipo === tipo.id ? 'border-2 border-amber-500 bg-amber-50' : ''}`}
                          draggable
                          onDragStart={(e) => handleTipoDragStart(e, tipo)}
                          onDragOver={(e) => handleTipoDragOver(e, tipo)}
                          onDragLeave={handleTipoDragLeave}
                          onDrop={(e) => handleTipoDrop(e, tipo)}
                          onDragEnd={handleTipoDragEnd}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <GripVertical className="h-5 w-5 text-stone-400" />
                              <div 
                                className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold text-sm"
                                style={{ backgroundColor: tipo.cor }}
                              >
                                {tipo.codigo || tipo.nome?.charAt(0)}
                              </div>
                              <div>
                                <p className="font-medium text-stone-900">{tipo.nome}</p>
                                {tipo.descricao && (
                                  <p className="text-sm text-stone-500">{tipo.descricao}</p>
                                )}
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <Button variant="ghost" size="sm" onClick={() => openEditTipo(tipo)}>
                                <Edit className="h-4 w-4" />
                              </Button>
                              <Button 
                                variant="ghost" 
                                size="sm"
                                className="text-red-500 hover:text-red-600 hover:bg-red-50"
                                onClick={() => handleDeleteTipo(tipo.id)}
                              >
                                <Trash2 className="h-4 w-4" />
                              </Button>
                            </div>
                          </div>
                        </Card>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Dialog Criar/Editar Tipo */}
      <Dialog open={showTipoDialog} onOpenChange={(open) => { setShowTipoDialog(open); if (!open) resetTipoForm(); }}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="font-heading">
              {editingTipo ? 'Editar Tipo de Anomalia' : 'Novo Tipo de Anomalia'}
            </DialogTitle>
            <DialogDescription>
              Configure um tipo de anomalia que os operadores podem reportar
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            {/* Classificação */}
            <div>
              <label className="block text-sm font-medium text-stone-700 mb-2">Classificação *</label>
              <div className="grid grid-cols-2 gap-3">
                {CLASSIFICACAO_ANOMALIA.map((classif) => (
                  <button
                    key={classif.id}
                    type="button"
                    onClick={() => setTipoForm(prev => ({ ...prev, classificacao: classif.id }))}
                    className={`p-4 rounded-xl border-2 text-left transition-all ${
                      tipoForm.classificacao === classif.id 
                        ? `${classif.color} border-current` 
                        : 'bg-white border-stone-200 hover:border-stone-300'
                    }`}
                  >
                    <div className="flex items-center gap-2 mb-1">
                      {classif.id === 'defeito' ? <XCircle className="h-5 w-5" /> : <Wrench className="h-5 w-5" />}
                      <span className="font-medium">{classif.label}</span>
                    </div>
                    <p className="text-xs opacity-70">{classif.description}</p>
                  </button>
                ))}
              </div>
            </div>
            
            {/* Nome */}
            <div>
              <label className="block text-sm font-medium text-stone-700 mb-1">Nome *</label>
              <Input
                placeholder="Ex: Material defeituoso"
                value={tipoForm.nome}
                onChange={(e) => setTipoForm(prev => ({ ...prev, nome: e.target.value }))}
              />
            </div>
            
            {/* Código */}
            <div>
              <label className="block text-sm font-medium text-stone-700 mb-1">Código *</label>
              <Input
                placeholder="Ex: DEF01"
                value={tipoForm.codigo}
                onChange={(e) => setTipoForm(prev => ({ ...prev, codigo: e.target.value.toUpperCase() }))}
                maxLength={6}
              />
              <p className="text-xs text-stone-400 mt-1">Código curto para identificação rápida</p>
            </div>
            
            {/* Cor */}
            <div>
              <label className="block text-sm font-medium text-stone-700 mb-2">Cor</label>
              <div className="flex flex-wrap gap-2">
                {CORES_DISPONIVEIS.map((cor) => (
                  <button
                    key={cor.value}
                    type="button"
                    onClick={() => setTipoForm(prev => ({ ...prev, cor: cor.value }))}
                    className={`w-8 h-8 rounded-lg transition-all ${
                      tipoForm.cor === cor.value ? 'ring-2 ring-offset-2 ring-stone-400 scale-110' : ''
                    }`}
                    style={{ backgroundColor: cor.value }}
                    title={cor.label}
                  />
                ))}
              </div>
            </div>
            
            {/* Descrição */}
            <div>
              <label className="block text-sm font-medium text-stone-700 mb-1">Descrição (opcional)</label>
              <Input
                placeholder="Descreva quando este tipo deve ser usado..."
                value={tipoForm.descricao}
                onChange={(e) => setTipoForm(prev => ({ ...prev, descricao: e.target.value }))}
              />
            </div>
            
            {/* Pré-visualização */}
            <div className="p-4 bg-stone-50 rounded-lg">
              <p className="text-xs text-stone-500 mb-2">Pré-visualização:</p>
              <div className="flex items-center gap-3">
                <div 
                  className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold text-sm"
                  style={{ backgroundColor: tipoForm.cor }}
                >
                  {tipoForm.codigo || '???'}
                </div>
                <div>
                  <p className="font-medium text-stone-900">{tipoForm.nome || 'Nome do tipo'}</p>
                  <span className={`text-xs px-2 py-0.5 rounded ${
                    tipoForm.classificacao === 'arranjo' 
                      ? 'bg-amber-100 text-amber-700' 
                      : 'bg-red-100 text-red-700'
                  }`}>
                    {tipoForm.classificacao === 'arranjo' ? 'Para Arranjo' : 'Defeito'}
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowTipoDialog(false)}>Cancelar</Button>
            <Button onClick={handleSaveTipo}>
              {editingTipo ? 'Guardar Alterações' : 'Criar Tipo'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Histórico */}
      <Dialog open={showHistoricoDialog} onOpenChange={setShowHistoricoDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Activity className="h-5 w-5 text-blue-500" />
              Histórico de Movimentações
            </DialogTitle>
            <DialogDescription>
              Registo de todas as acções desta anomalia
            </DialogDescription>
          </DialogHeader>
          <div className="max-h-[50vh] overflow-y-auto space-y-3">
            {historicoSelecionado?.historico?.map((item, idx) => (
              <div key={idx} className="flex gap-3 p-3 bg-stone-50 rounded-lg">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${
                  item.acao === 'criado' ? 'bg-blue-100 text-blue-600' :
                  item.acao === 'resgatado' ? 'bg-amber-100 text-amber-600' :
                  item.acao === 'reinserido' ? 'bg-green-100 text-green-600' :
                  'bg-stone-100 text-stone-600'
                }`}>
                  {item.acao === 'criado' ? '➕' :
                   item.acao === 'resgatado' ? '📦' :
                   item.acao === 'reinserido' ? '✓' : '•'}
                </div>
                <div className="flex-1">
                  <p className="font-medium text-sm capitalize">{String(item.acao || '')}</p>
                  {item.observacao && <p className="text-xs text-stone-500">{String(item.observacao)}</p>}
                  {item.quantidade && <p className="text-xs text-stone-600">{item.quantidade} peças</p>}
                  <p className="text-xs text-stone-400 mt-1">
                    {new Date(item.data).toLocaleString('pt-PT')}
                  </p>
                </div>
              </div>
            ))}
            {(!historicoSelecionado?.historico || historicoSelecionado.historico.length === 0) && (
              <p className="text-center text-stone-500 py-4">Sem histórico disponível</p>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Sheet de Gestão de Resgate REMOVIDO — accoes agora directas no card */}


      {/* Dialog de Editar Resgate */}
      <Dialog open={showEditResgateDialog} onOpenChange={setShowEditResgateDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Edit className="h-5 w-5 text-blue-500" />
              Editar Resgate
            </DialogTitle>
            <DialogDescription>
              {resgateSelecionado?.numero_resgate}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div>
              <label className="text-sm font-medium">Status</label>
              <select
                className="w-full p-2 border rounded-lg text-sm mt-1"
                value={editResgateData.status}
                onChange={(e) => setEditResgateData(prev => ({ ...prev, status: e.target.value }))}
              >
                <option value="em_arranjo">Em Arranjo</option>
                <option value="parcial">Parcial</option>
                <option value="concluido">Concluído</option>
              </select>
            </div>
            
            <div>
              <label className="text-sm font-medium">Prioridade</label>
              <select
                className="w-full p-2 border rounded-lg text-sm mt-1"
                value={editResgateData.prioridade}
                onChange={(e) => setEditResgateData(prev => ({ ...prev, prioridade: parseInt(e.target.value) }))}
              >
                <option value={1}>Alta (Urgente)</option>
                <option value={2}>Média (Normal)</option>
                <option value={3}>Baixa</option>
              </select>
            </div>
            
            <div>
              <label className="text-sm font-medium">Observações</label>
              <textarea
                className="w-full p-2 border rounded-lg text-sm mt-1 min-h-[80px]"
                placeholder="Notas sobre este resgate..."
                value={editResgateData.observacoes}
                onChange={(e) => setEditResgateData(prev => ({ ...prev, observacoes: e.target.value }))}
              />
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowEditResgateDialog(false)}>
              Cancelar
            </Button>
            <Button onClick={handleSaveResgate}>
              <CheckCircle className="h-4 w-4 mr-2" />
              Guardar Alterações
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Confirmar Apagar */}
      <Dialog open={showDeleteConfirm} onOpenChange={setShowDeleteConfirm}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <Trash2 className="h-5 w-5" />
              Apagar Resgate
            </DialogTitle>
            <DialogDescription>
              Tem a certeza que deseja apagar o resgate <strong>{resgateSelecionado?.numero_resgate}</strong>?
              <br /><br />
              Esta ação não pode ser revertida.
            </DialogDescription>
          </DialogHeader>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowDeleteConfirm(false)}>
              Cancelar
            </Button>
            <Button 
              className="bg-red-600 hover:bg-red-700"
              onClick={handleDeleteResgate}
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Apagar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Reinserir Peças */}
      <Dialog open={showReinserirDialog} onOpenChange={setShowReinserirDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <RotateCcw className="h-5 w-5 text-green-500" />
              Reinserir Peças na Produção
            </DialogTitle>
            <DialogDescription>
              Selecione a operação onde as peças serão reinseridas. As peças entrarão nessa operação e continuarão nas seguintes.
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            {/* Selector de Operação Destino - Agrupado por Categoria */}
            <div>
              <label className="text-sm font-medium">Operação de entrada *</label>
              <p className="text-xs text-stone-500 mb-2">
                As peças serão inseridas nesta operação e continuarão nas operações seguintes
              </p>
              
              {/* Lista de operações agrupadas por categoria */}
              <div className="max-h-[200px] overflow-y-auto border rounded-lg">
                {(() => {
                  // Agrupar operações por categoria
                  const operacoesPorCategoria = {};
                  const categoriasCores = {
                    'Peças': 'bg-blue-50 border-blue-200',
                    'Acessórios': 'bg-purple-50 border-purple-200',
                    'Estrutura': 'bg-amber-50 border-amber-200',
                    'Acabamento': 'bg-green-50 border-green-200',
                    'Embalagem': 'bg-stone-50 border-stone-200',
                    'Preparação': 'bg-cyan-50 border-cyan-200',
                    'Intermédios': 'bg-indigo-50 border-indigo-200'
                  };
                  
                  resgateSelecionado?.operacoes_falta?.forEach((opId, idx) => {
                    const categoria = resgateSelecionado?.operacoes_falta_categorias?.[idx] || 'Outras';
                    if (!operacoesPorCategoria[categoria]) {
                      operacoesPorCategoria[categoria] = [];
                    }
                    // Usar o nome fornecido pelo backend primeiro (fonte de verdade)
                    // Só faz lookup local se o nome do backend for um ID (fallback)
                    const nomeDoBackend = resgateSelecionado?.operacoes_falta_nomes?.[idx];
                    const eIdEmVezDeNome = nomeDoBackend && nomeDoBackend.includes('-') && nomeDoBackend.length > 30;
                    
                    let nomeOperacao;
                    if (!eIdEmVezDeNome && nomeDoBackend) {
                      // Backend forneceu nome válido
                      nomeOperacao = nomeDoBackend;
                    } else {
                      // Fallback: buscar na lista local de operações
                      const operacaoInfo = operacoes.find(o => o.id === opId);
                      nomeOperacao = operacaoInfo 
                        ? `${operacaoInfo.codigo || ''} - ${operacaoInfo.nome}`.replace(/^- /, '')
                        : `Operação ${idx + 1}`;
                    }
                    
                    operacoesPorCategoria[categoria].push({
                      id: opId,
                      nome: nomeOperacao,
                      ordem: idx + 1
                    });
                  });
                  
                  return Object.entries(operacoesPorCategoria).map(([categoria, ops]) => (
                    <div key={categoria} className={`border-b last:border-b-0 ${categoriasCores[categoria] || 'bg-stone-50'}`}>
                      <div className="px-3 py-1.5 text-xs font-semibold text-stone-600 uppercase tracking-wider bg-white/50">
                        {categoria || 'Operações'}
                      </div>
                      {ops.map(op => (
                        <button
                          key={op.id}
                          type="button"
                          onClick={() => setReinserirData(prev => ({ ...prev, operacao_destino_id: op.id }))}
                          className={`w-full text-left px-3 py-2 text-sm hover:bg-white/80 transition-colors flex items-center justify-between ${
                            reinserirData.operacao_destino_id === op.id ? 'bg-green-100 text-green-700' : ''
                          }`}
                        >
                          <span className="flex items-center gap-2">
                            <span className="w-5 h-5 bg-stone-200 text-stone-600 rounded-full flex items-center justify-center text-xs font-bold">
                              {op.ordem}
                            </span>
                            <span>{op.nome}</span>
                          </span>
                          {reinserirData.operacao_destino_id === op.id && (
                            <CheckCircle className="h-4 w-4 text-green-600" />
                          )}
                        </button>
                      ))}
                    </div>
                  ));
                })()}
              </div>
              
              {reinserirData.operacao_destino_id && (
                <p className="text-xs text-green-600 mt-2 flex items-center gap-1">
                  <CheckCircle className="h-3 w-3" />
                  As peças serão processadas a partir desta operação
                </p>
              )}
            </div>

            <div>
              <label className="text-sm font-medium">Quantidade a reinserir</label>
              <Input 
                type="number"
                min={1}
                max={resgateSelecionado?.quantidade_total - (resgateSelecionado?.quantidade_recuperada || 0)}
                value={reinserirData.quantidade}
                onChange={(e) => setReinserirData(prev => ({ ...prev, quantidade: parseInt(e.target.value) || 0 }))}
                className="mt-1"
              />
              <p className="text-xs text-stone-400 mt-1">
                Máximo: {resgateSelecionado?.quantidade_total - (resgateSelecionado?.quantidade_recuperada || 0)} peças
              </p>
            </div>
            
            <div>
              <label className="text-sm font-medium">Observações (opcional)</label>
              <Input 
                placeholder="Ex: Peças reparadas e verificadas"
                value={reinserirData.observacao}
                onChange={(e) => setReinserirData(prev => ({ ...prev, observacao: e.target.value }))}
                className="mt-1"
              />
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowReinserirDialog(false)}>
              Cancelar
            </Button>
            <Button 
              className="bg-green-600 hover:bg-green-700"
              onClick={handleReinserirPecas}
              disabled={reinserirData.quantidade <= 0 || !reinserirData.operacao_destino_id}
            >
              <CheckCircle className="h-4 w-4 mr-2" />
              Confirmar Reinserção
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Visualização de Foto */}
      <Dialog open={showFotoDialog} onOpenChange={setShowFotoDialog}>
        <DialogContent className="max-w-2xl p-0 overflow-hidden">
          <DialogHeader className="p-4 pb-0">
            <DialogTitle className="flex items-center gap-2">
              <Image className="h-5 w-5 text-blue-500" />
              Foto da Anomalia
            </DialogTitle>
          </DialogHeader>
          <div className="p-4">
            {fotoSelecionada && (
              <img 
                src={fotoSelecionada}
                alt="Foto da anomalia"
                className="w-full h-auto max-h-[60vh] object-contain rounded-lg"
              />
            )}
          </div>
          <DialogFooter className="p-4 pt-0">
            <Button variant="outline" onClick={() => setShowFotoDialog(false)}>
              Fechar
            </Button>
            {fotoSelecionada && (
              <Button onClick={() => window.open(fotoSelecionada, '_blank')}>
                <Download className="h-4 w-4 mr-2" />
                Download
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Detalhes da Anomalia - REMOVIDO conforme pedido do utilizador */}

      {/* Dialog de Terceirização */}
      <Dialog open={showGuiaTerceirizacao} onOpenChange={setShowGuiaTerceirizacao}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Truck className="h-5 w-5 text-orange-500" />
              Terceirizar Arranjo - {resgateSelecionado?.numero_resgate}
            </DialogTitle>
            <DialogDescription>
              Criar guia para enviar peças para arranjo externo
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-6 py-4">
            {/* Info de quantidade disponível */}
            {(() => {
              const qtdTotal = resgateSelecionado?.quantidade_total || 0;
              const qtdRecuperada = resgateSelecionado?.quantidade_recuperada || 0;
              const qtdEmGuias = guiasResgate.filter(g => g.status !== 'devolvido').reduce((acc, g) => acc + (g.quantidade || 0), 0);
              const qtdDisponivel = Math.max(0, qtdTotal - qtdRecuperada - qtdEmGuias);
              
              return (
                <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-blue-700 font-medium">Quantidade disponível para terceirização</p>
                      <p className="text-xs text-blue-600">
                        Total: {qtdTotal} | Reinseridas: {qtdRecuperada} | Em guias: {qtdEmGuias}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className={`text-2xl font-bold ${qtdDisponivel > 0 ? 'text-blue-700' : 'text-stone-400'}`}>
                        {qtdDisponivel}
                      </p>
                      <p className="text-xs text-blue-600">peças disponíveis</p>
                    </div>
                  </div>
                </div>
              );
            })()}
            
            {/* Formulário Nova Guia */}
            <div className="p-4 border-2 border-dashed border-orange-200 rounded-xl bg-orange-50/30">
              <h4 className="font-semibold text-orange-700 mb-3 flex items-center gap-2">
                <FileOutput className="h-4 w-4" />
                Nova Guia de Arranjo Externo
              </h4>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-stone-600 mb-1">N.º Guia *</label>
                  <Input 
                    value={novaGuia.numero_guia}
                    onChange={(e) => setNovaGuia(prev => ({ ...prev, numero_guia: e.target.value }))}
                    placeholder="Ex: G2026-001"
                  />
                </div>
                <div>
                  {(() => {
                    const qtdTotal = resgateSelecionado?.quantidade_total || 0;
                    const qtdRecuperada = resgateSelecionado?.quantidade_recuperada || 0;
                    const qtdEmGuias = guiasResgate.filter(g => g.status !== 'devolvido').reduce((acc, g) => acc + (g.quantidade || 0), 0);
                    const qtdDisponivel = Math.max(0, qtdTotal - qtdRecuperada - qtdEmGuias);
                    
                    return (
                      <>
                        <label className="block text-xs font-medium text-stone-600 mb-1">
                          Quantidade * <span className="text-blue-600 font-normal">(máx: {qtdDisponivel})</span>
                        </label>
                        <Input 
                          type="number"
                          min={1}
                          max={qtdDisponivel}
                          value={novaGuia.quantidade === 0 ? '' : novaGuia.quantidade}
                          onChange={(e) => {
                            const v = e.target.value;
                            setNovaGuia(prev => ({ ...prev, quantidade: v === '' ? 0 : parseInt(v) || 0 }));
                          }}
                          onFocus={(e) => e.target.select()}
                          placeholder={`Máx: ${qtdDisponivel}`}
                          disabled={qtdDisponivel <= 0}
                          data-testid="terc-quantidade-input"
                        />
                      </>
                    );
                  })()}
                </div>
                <div>
                  <label className="block text-xs font-medium text-stone-600 mb-1">Nome Confecção</label>
                  <Input 
                    value={novaGuia.nome_confecao}
                    onChange={(e) => setNovaGuia(prev => ({ ...prev, nome_confecao: e.target.value }))}
                    placeholder="Ex: Confecções ABC"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-stone-600 mb-1">Descrição</label>
                  <Input 
                    value={novaGuia.descricao}
                    onChange={(e) => setNovaGuia(prev => ({ ...prev, descricao: e.target.value }))}
                    placeholder="Ex: Costura de botões"
                  />
                </div>
              </div>
              <Button 
                className="mt-3 bg-orange-600 hover:bg-orange-700"
                onClick={handleCriarGuia}
                disabled={!novaGuia.numero_guia || novaGuia.quantidade <= 0}
              >
                <Send className="h-4 w-4 mr-2" />
                Criar Guia e Gerar PDF
              </Button>
            </div>

            {/* Lista de Guias Existentes */}
            {guiasResgate.length > 0 && (
              <div>
                <h4 className="font-semibold text-stone-700 mb-3">Guias Criadas ({guiasResgate.length})</h4>
                <div className="space-y-2">
                  {guiasResgate.map(guia => (
                    <div key={guia.id} className={`p-3 rounded-lg border ${
                      guia.status === 'concluido' ? 'bg-green-50 border-green-200' :
                      guia.status === 'parcialmente_devolvido' ? 'bg-amber-50 border-amber-200' :
                      'bg-stone-50 border-stone-200'
                    }`}>
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-3">
                          <span className="font-bold text-stone-800">Guia {guia.numero_guia}</span>
                          <span className={`text-xs px-2 py-0.5 rounded ${
                            guia.status === 'concluido' ? 'bg-green-200 text-green-700' :
                            guia.status === 'parcialmente_devolvido' ? 'bg-amber-200 text-amber-700' :
                            'bg-stone-200 text-stone-600'
                          }`}>
                            {guia.status === 'enviado' ? 'Enviado' : 
                             guia.status === 'parcialmente_devolvido' ? 'Parcial' : 
                             guia.status === 'concluido' ? 'Concluído' : guia.status}
                          </span>
                        </div>
                        <div className="flex gap-1">
                          <Button size="sm" variant="ghost" onClick={() => handleDownloadGuiaPDF(guia.id)} title="Download PDF">
                            <Download className="h-4 w-4" />
                          </Button>
                          <Button size="sm" variant="ghost" onClick={() => handleAbrirEditGuia(guia)} title="Registar devoluções">
                            <Edit className="h-4 w-4" />
                          </Button>
                          {guia.status === 'enviado' && (
                            <Button 
                              size="sm" 
                              variant="ghost" 
                              className="text-red-600 hover:text-red-700 hover:bg-red-50"
                              onClick={() => {
                                setGuiaParaEliminar(guia);
                                setShowDeleteGuiaConfirm(true);
                              }}
                              title="Eliminar guia"
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 gap-2 text-xs">
                        <div>
                          <span className="text-stone-500">Enviadas:</span>
                          <span className="ml-1 font-medium">{guia.quantidade}</span>
                        </div>
                        <div>
                          <span className="text-stone-500">Recebidas:</span>
                          <span className="ml-1 font-medium">{guia.total_recebido || 0}</span>
                        </div>
                        <div>
                          <span className="text-stone-500">Faltam:</span>
                          <span className="ml-1 font-medium text-red-600">{guia.quantas_faltam || guia.quantidade}</span>
                        </div>
                      </div>
                      {guia.nome_confecao && (
                        <p className="text-xs text-stone-500 mt-1">Confecção: {guia.nome_confecao}</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowGuiaTerceirizacao(false)}>
              Fechar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Editar Guia (Devoluções) */}
      <Dialog open={showEditGuia} onOpenChange={setShowEditGuia}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Edit className="h-5 w-5 text-blue-500" />
              Registar Devoluções - Guia {guiaSelecionada?.numero_guia}
            </DialogTitle>
            <DialogDescription>
              Registe as devoluções de peças (até 3 entregas)
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            {/* 3 Entregas */}
            {[0, 1, 2].map(idx => (
              <div key={idx} className="p-3 bg-stone-50 rounded-lg">
                <h5 className="text-sm font-medium text-stone-700 mb-2">Entrega {idx + 1}</h5>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <label className="block text-xs text-stone-500">Data</label>
                    <Input 
                      type="date"
                      value={editGuiaData.entregas[idx]?.data || ''}
                      onChange={(e) => {
                        const newEntregas = [...editGuiaData.entregas];
                        newEntregas[idx] = { ...newEntregas[idx], data: e.target.value };
                        setEditGuiaData(prev => ({ ...prev, entregas: newEntregas }));
                      }}
                      className="text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-stone-500">Quantidade</label>
                    <Input 
                      type="number"
                      min={0}
                      value={editGuiaData.entregas[idx]?.quantidade_recebida || ''}
                      onChange={(e) => {
                        const newEntregas = [...editGuiaData.entregas];
                        newEntregas[idx] = { ...newEntregas[idx], quantidade_recebida: parseInt(e.target.value) || 0 };
                        setEditGuiaData(prev => ({ ...prev, entregas: newEntregas }));
                      }}
                      className="text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-stone-500">Obs.</label>
                    <Input 
                      value={editGuiaData.entregas[idx]?.observacoes || ''}
                      onChange={(e) => {
                        const newEntregas = [...editGuiaData.entregas];
                        newEntregas[idx] = { ...newEntregas[idx], observacoes: e.target.value };
                        setEditGuiaData(prev => ({ ...prev, entregas: newEntregas }));
                      }}
                      className="text-sm"
                      placeholder="Opcional"
                    />
                  </div>
                </div>
              </div>
            ))}

            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-stone-600 mb-1">Peças c/ Defeito</label>
                <Input 
                  type="number"
                  min={0}
                  value={editGuiaData.pecas_com_defeito}
                  onChange={(e) => setEditGuiaData(prev => ({ ...prev, pecas_com_defeito: parseInt(e.target.value) || 0 }))}
                  placeholder="Não recuperadas"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-600 mb-1">Observações Finais</label>
                <Input 
                  value={editGuiaData.observacoes_finais}
                  onChange={(e) => setEditGuiaData(prev => ({ ...prev, observacoes_finais: e.target.value }))}
                  placeholder="Opcional"
                />
              </div>
            </div>

            {/* Resumo */}
            <div className="p-3 bg-blue-50 rounded-lg">
              <p className="text-sm font-medium text-blue-700">Resumo</p>
              <div className="grid grid-cols-3 gap-2 text-sm mt-1">
                <div>Enviadas: {guiaSelecionada?.quantidade || 0}</div>
                <div>Recebidas: {editGuiaData.entregas.reduce((acc, e) => acc + (e.quantidade_recebida || 0), 0)}</div>
                <div>Defeito: {editGuiaData.pecas_com_defeito}</div>
              </div>
            </div>
          </div>
          
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowEditGuia(false)}>
              Cancelar
            </Button>
            <Button onClick={handleSaveGuia}>
              Guardar e Actualizar PDF
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog de Confirmação de Eliminação de Guia */}
      <Dialog open={showDeleteGuiaConfirm} onOpenChange={setShowDeleteGuiaConfirm}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-red-600">
              <Trash2 className="h-5 w-5" />
              Eliminar Guia de Terceirização
            </DialogTitle>
            <DialogDescription>
              Tem a certeza que deseja eliminar esta guia?
            </DialogDescription>
          </DialogHeader>
          
          {guiaParaEliminar && (
            <div className="py-4 space-y-3">
              <div className="p-3 bg-red-50 rounded-lg border border-red-200">
                <p className="font-medium text-red-800">Guia: {guiaParaEliminar.numero_guia}</p>
                <p className="text-sm text-red-600">Quantidade: {guiaParaEliminar.quantidade} peças</p>
                {guiaParaEliminar.nome_confecao && (
                  <p className="text-sm text-red-600">Confecção: {guiaParaEliminar.nome_confecao}</p>
                )}
              </div>
              <p className="text-sm text-stone-600">
                As {guiaParaEliminar.quantidade} peças ficarão novamente disponíveis para terceirização ou reinserção.
              </p>
            </div>
          )}
          
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setShowDeleteGuiaConfirm(false)}>
              Cancelar
            </Button>
            <Button 
              variant="destructive" 
              onClick={handleEliminarGuia}
              className="bg-red-600 hover:bg-red-700"
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Eliminar Guia
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Criar Resgate - Fluxo OF-first */}
      <Dialog open={showCriarResgateModal} onOpenChange={(open) => {
        if (!open) {
          setOfSelecionadaResgate('');
          setAnomaliasSelecionadasParaResgate({});
          setClassificacoesPerda({});
          setNomeResgate('');
          setSearchOFResgate('');
        }
        setShowCriarResgateModal(open);
      }}>
        <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-xl font-heading flex items-center gap-2">
              <Truck className="h-5 w-5 text-red-600" />
              Criar Terceirização
            </DialogTitle>
            <DialogDescription>
              Selecione a Ordem de Fabrico e as peças de arranjo já classificadas que deseja terceirizar
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-5 mt-4">
            {/* PASSO 1: Selecionar OF - Dropdown com pesquisa */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-stone-700 flex items-center gap-2">
                <span className="w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-xs">1</span>
                Ordem de Fabrico
              </label>
              
              {/* Dropdown de seleção com pesquisa visual — só aparece se nenhuma OF estiver selecionada */}
              {!ofSelecionadaResgate && (
              <div className="relative">
                {(() => {
                  const ofsComAnomalias = Array.from(new Set(anomaliasParaResgate.map(a => a.of_id)))
                    .map(ofId => {
                      const of = ofs.find(o => o.id === ofId);
                      const anomaliasOF = anomaliasParaResgate.filter(a => a.of_id === ofId);
                      const totalPecas = anomaliasOF.reduce((sum, a) => sum + getQuantidadeDisponivelResgate(a), 0);
                      return { ofId, of, totalPecas };
                    });
                  
                  // Mapeamento de estados (cor + label)
                  const estadoLabel = {
                    'rascunho': { text: 'Rascunho', color: 'bg-stone-100 text-stone-600 border-stone-300' },
                    'aguardar_entrada': { text: 'Aguardar', color: 'bg-yellow-100 text-yellow-700 border-yellow-300' },
                    'em_curso': { text: 'Em Curso', color: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
                    'pausada': { text: 'Pausada', color: 'bg-orange-100 text-orange-700 border-orange-300' },
                    'concluida': { text: 'Concluída', color: 'bg-green-100 text-green-700 border-green-300' },
                    'cancelada': { text: 'Cancelada', color: 'bg-red-100 text-red-700 border-red-300' }
                  };
                  
                  // Aplicar pesquisa + filtro de estado
                  const termo = (searchOFResgate || '').trim().toLowerCase();
                  const isStatus = ['rascunho','aguardar_entrada','em_curso','pausada','concluida','cancelada'].includes(termo);
                  const filtradas = ofsComAnomalias.filter(({ of }) => {
                    if (!termo) return true;
                    if (isStatus) return (of?.estado_of || '').toLowerCase() === termo;
                    const blob = `${of?.numero_of || ''} ${of?.artigo || ''} ${of?.cliente || ''} ${(estadoLabel[of?.estado_of]?.text || '').toLowerCase()}`.toLowerCase();
                    return blob.includes(termo);
                  });
                  
                  return (
                    <div className="space-y-2">
                      {/* Caixa de pesquisa */}
                      <div className="relative">
                        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-stone-400" />
                        <input
                          type="text"
                          value={searchOFResgate}
                          onChange={(e) => setSearchOFResgate(e.target.value)}
                          placeholder="Pesquisar por nº OF, artigo, cliente ou estado (em_curso, pausada, ...)"
                          className="w-full pl-8 pr-3 py-2 text-sm border rounded-lg bg-white focus:ring-2 focus:ring-blue-200 focus:border-blue-400"
                          data-testid="searchbox-of-resgate"
                        />
                      </div>
                      {/* Filtros rápidos por estado */}
                      <div className="flex items-center gap-1 flex-wrap">
                        <button type="button" onClick={() => setSearchOFResgate('')} className={`text-[11px] px-2 py-0.5 rounded-full border ${!searchOFResgate ? 'bg-blue-50 border-blue-300 text-blue-700' : 'bg-white border-stone-200 text-stone-500'}`}>Todos</button>
                        {Object.entries(estadoLabel).map(([k, info]) => {
                          const cnt = ofsComAnomalias.filter(({ of }) => (of?.estado_of || 'rascunho') === k).length;
                          if (cnt === 0) return null;
                          const ativo = (searchOFResgate || '').toLowerCase() === k;
                          return (
                            <button
                              key={k}
                              type="button"
                              onClick={() => setSearchOFResgate(ativo ? '' : k)}
                              className={`text-[11px] px-2 py-0.5 rounded-full border ${ativo ? info.color + ' ring-2 ring-offset-1 ring-blue-300' : info.color}`}
                              data-testid={`filtro-estado-${k}`}
                            >
                              {info.text} <span className="opacity-70">({cnt})</span>
                            </button>
                          );
                        })}
                      </div>
                      {/* Lista de OFs filtradas */}
                      <div className="max-h-64 overflow-y-auto border rounded-lg divide-y bg-white">
                        {filtradas.length === 0 ? (
                          <div className="p-4 text-center text-xs text-stone-400">Sem resultados</div>
                        ) : filtradas.map(({ ofId, of, totalPecas }) => {
                          const estado = of?.estado_of || 'rascunho';
                          const estadoInfo = estadoLabel[estado] || { text: estado, color: 'bg-stone-100 text-stone-600 border-stone-300' };
                          const numeroOF = of?.numero_of || `Anomalia ${ofId.substring(0, 8)}`;
                          const isAtiva = ofSelecionadaResgate === ofId;
                          return (
                            <button
                              type="button"
                              key={ofId}
                              onClick={() => {
                                setOfSelecionadaResgate(ofId);
                                setAnomaliasSelecionadasParaResgate({});
                              }}
                              className={`w-full text-left px-3 py-2 text-sm flex items-center justify-between hover:bg-blue-50 transition ${isAtiva ? 'bg-blue-100' : ''}`}
                              data-testid={`opt-of-resgate-${ofId}`}
                            >
                              <div className="flex flex-col min-w-0">
                                <div className="flex items-center gap-2">
                                  <span className="font-bold text-stone-800">{numeroOF}</span>
                                  <span className={`text-[10px] px-1.5 py-0.5 rounded-full border ${estadoInfo.color}`}>{estadoInfo.text}</span>
                                  {isAtiva && <span className="text-[10px] text-blue-700">✓ selecionada</span>}
                                </div>
                                <span className="text-[11px] text-stone-500 truncate">{of?.artigo || of?.cliente || '—'}</span>
                              </div>
                              <span className="text-xs font-bold text-stone-700 whitespace-nowrap">{totalPecas} peças</span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
              </div>
              )}
              
              {/* Info da OF selecionada */}
              {ofSelecionadaResgate && (() => {
                const of = ofs.find(o => o.id === ofSelecionadaResgate);
                const anomaliasOF = anomaliasParaResgate.filter(a => a.of_id === ofSelecionadaResgate);
                const totalPecas = anomaliasOF.reduce((sum, a) => sum + getQuantidadeDisponivelResgate(a), 0);
                const estadoLabel = {
                  'rascunho': { text: 'Rascunho', color: 'bg-stone-100 text-stone-600' },
                  'aguardar_entrada': { text: 'Aguardar', color: 'bg-yellow-100 text-yellow-700' },
                  'em_curso': { text: 'Em Curso', color: 'bg-emerald-100 text-emerald-700' },
                  'pausada': { text: 'Pausada', color: 'bg-orange-100 text-orange-700' },
                  'concluida': { text: 'Concluída', color: 'bg-green-100 text-green-700' },
                  'cancelada': { text: 'Cancelada', color: 'bg-red-100 text-red-700' }
                };
                const estado = of?.estado_of || 'rascunho';
                const estadoInfo = estadoLabel[estado] || { text: estado, color: 'bg-stone-100 text-stone-600' };
                
                return (
                  <div className="flex items-center justify-between p-3 bg-blue-50 rounded-lg border border-blue-200">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                        <Package className="h-5 w-5 text-blue-600" />
                      </div>
                      <div>
                        <p className="font-bold text-navy">{of?.numero_of || `Anomalia ${ofSelecionadaResgate.substring(0, 8)}`}</p>
                        <p className="text-xs text-stone-500">
                          {of?.artigo || ''}{of?.artigo && of?.cliente ? ' • ' : ''}{of?.cliente || ''}
                        </p>
                      </div>
                      <span className={`text-xs px-2 py-0.5 rounded-full ${estadoInfo.color}`}>
                        {estadoInfo.text}
                      </span>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="text-right">
                        <p className="text-2xl font-bold text-blue-600">{totalPecas}</p>
                        <p className="text-xs text-stone-500">peças disponíveis</p>
                      </div>
                      <button
                        type="button"
                        onClick={() => {
                          setOfSelecionadaResgate('');
                          setAnomaliasSelecionadasParaResgate({});
                        }}
                        className="text-xs px-3 py-1.5 rounded-lg border border-blue-300 bg-white text-blue-700 hover:bg-blue-100 transition font-medium"
                        data-testid="btn-alterar-of-resgate"
                      >
                        Alterar OF
                      </button>
                    </div>
                  </div>
                );
              })()}
            </div>
            
            {/* PASSO 2: Mostrar anomalias da OF selecionada */}
            {ofSelecionadaResgate && (
              <>
                {/* Lista de anomalias da OF */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-stone-700 flex items-center gap-2">
                    <span className="w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-xs">2</span>
                    Selecione as peças para resgate
                  </label>
                  
                  {(() => {
                    const anomaliasOF = anomaliasParaResgate.filter(a => a.of_id === ofSelecionadaResgate);
                    // Agrupar por categoria
                    const porCategoria = anomaliasOF.reduce((acc, anomalia) => {
                      const operacao = operacoes.find(op => op.id === anomalia.operacao_id);
                      const categoriaNome = operacao?.categoria || 'Sem Categoria';
                      if (!acc[categoriaNome]) acc[categoriaNome] = [];
                      acc[categoriaNome].push({
                        ...anomalia,
                        operacao_nome: operacao?.nome || 'Operação desconhecida',
                        of: ofs.find(o => o.id === anomalia.of_id)
                      });
                      return acc;
                    }, {});
                    
                    return Object.entries(porCategoria).length === 0 ? (
                      <div className="text-center py-8 text-stone-400">
                        <Package className="h-12 w-12 mx-auto mb-2 opacity-50" />
                        <p>Não há anomalias (arranjos ou defeitos) disponíveis nesta OF</p>
                      </div>
                    ) : (
                      Object.entries(porCategoria).map(([categoria, anomaliasCat]) => (
                        <div key={categoria} className="border rounded-lg overflow-hidden">
                          <div className="bg-stone-100 px-4 py-2 font-medium text-stone-700 flex items-center justify-between">
                            <span>{categoria}</span>
                            <span className="text-sm text-stone-500">{anomaliasCat.length} anomalias</span>
                          </div>
                          <div className="divide-y">
                            {anomaliasCat.map((anomalia) => {
                              const disponiveis = getQuantidadeDisponivelResgate(anomalia);
                              const selecionado = anomaliasSelecionadasParaResgate[anomalia.id] || 0;
                              const isDefeito = anomalia.tipo === 'defeito';
                              const isClassificado = anomalia.quantidade_classificada === true;
                              const labelTipo = anomalia.label_tipo || (isDefeito ? 'Defeito' : 'Arranjo');
                              
                              return (
                                <div key={anomalia.id} className={`p-3 hover:bg-stone-50 ${isDefeito ? 'border-l-4 border-l-red-400' : 'border-l-4 border-l-amber-400'}`}>
                                  <div className="flex items-center gap-4">
                                    <div className="flex-1">
                                      <div className="flex items-center gap-2">
                                        <p className="font-medium text-sm">
                                          {anomalia.operacao_nome}
                                        </p>
                                        <span className={`text-xs px-2 py-0.5 rounded-full ${isDefeito ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
                                          {labelTipo}
                                        </span>
                                        {isClassificado && (
                                          <span className="text-xs px-2 py-0.5 rounded-full bg-blue-100 text-blue-700">
                                            Classificado
                                          </span>
                                        )}
                                      </div>
                                      <p className="text-xs text-stone-500">
                                        {anomalia.razao || anomalia.observacoes || 'Sem observações'}
                                      </p>
                                    </div>
                                    <div className="text-right text-sm">
                                      <p className="text-stone-500">Disponível</p>
                                      <p className="font-bold">{disponiveis} un</p>
                                    </div>
                                    <div className="w-24">
                                      <Input
                                        type="number"
                                        min={0}
                                        max={disponiveis}
                                        value={selecionado}
                                        onChange={(e) => {
                                          const val = Math.min(Math.max(0, parseInt(e.target.value) || 0), disponiveis);
                                          setAnomaliasSelecionadasParaResgate(prev => ({
                                            ...prev,
                                            [anomalia.id]: val
                                          }));
                                        }}
                                        placeholder="0"
                                        className="h-8 text-center"
                                      />
                                    </div>
                                    <Button
                                      size="sm"
                                      variant={selecionado === disponiveis ? 'default' : 'outline'}
                                      onClick={() => {
                                        setAnomaliasSelecionadasParaResgate(prev => ({
                                          ...prev,
                                          [anomalia.id]: selecionado === disponiveis ? 0 : disponiveis
                                        }));
                                      }}
                                    >
                                      {selecionado === disponiveis ? 'Limpar' : 'Tudo'}
                                    </Button>
                                  </div>
                                  
                                  {/* Tipos de Arranjo já selecionados anteriormente (info read-only) */}
                                  {!isDefeito && selecionado > 0 && (() => {
                                    const tiposIndividuais = (anomalia.tipos_individuais_arranjo || []).filter(Boolean);
                                    const tipoUnicoId = anomalia.tipo_problema_arranjo_id;
                                    const todosTiposIds = tiposIndividuais.length > 0
                                      ? Array.from(new Set(tiposIndividuais))
                                      : (tipoUnicoId ? [tipoUnicoId] : []);
                                    const tiposLabels = todosTiposIds
                                      .map(tid => {
                                        const t = (tiposAnomalia || []).find(tp => tp.id === tid);
                                        return t ? (t.nome || t.codigo) : null;
                                      })
                                      .filter(Boolean);
                                    if (tiposLabels.length === 0) {
                                      return (
                                        <div className="mt-2 p-2 bg-stone-50 rounded-lg border border-stone-200 text-[11px] text-stone-500 italic">
                                          Sem tipo de arranjo selecionado anteriormente.
                                        </div>
                                      );
                                    }
                                    return (
                                      <div className="mt-2 p-2 bg-amber-50 rounded-lg border border-amber-200">
                                        <p className="text-[10px] uppercase font-semibold text-amber-700 mb-1">Tipos de Arranjo já classificados</p>
                                        <div className="flex flex-wrap gap-1">
                                          {tiposLabels.map((label, i) => (
                                            <span key={i} className="text-[11px] px-2 py-0.5 rounded-full bg-amber-100 border border-amber-300 text-amber-800">
                                              {label}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
                                    );
                                  })()}
                                  
                                  {/* Classificação por tipo para DEFEITOS - distribuir por tipo */}
                                  {isDefeito && selecionado > 0 && (
                                    <div className="mt-3 p-4 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl border border-amber-200 shadow-sm">
                                      <div className="flex items-center justify-between mb-3 pb-2 border-b border-amber-200/50">
                                        <label className="text-sm font-semibold text-amber-800 flex items-center gap-2">
                                          <span className="w-6 h-6 rounded-full bg-amber-200 flex items-center justify-center text-xs">🔧</span>
                                          Classificação por Tipo
                                        </label>
                                        <span className={`text-sm font-bold px-2.5 py-0.5 rounded-full ${
                                          getTotalClassificadoArranjo(anomalia.id) === selecionado 
                                            ? 'bg-green-100 text-green-700' 
                                            : 'bg-amber-100 text-amber-700'
                                        }`}>
                                          {getTotalClassificadoArranjo(anomalia.id)}/{selecionado}
                                        </span>
                                      </div>
                                      
                                      {/* Linhas de classificação */}
                                      <div className="space-y-2">
                                        {(classificacoesArranjo[anomalia.id] || []).map((classif, idx) => (
                                          <div key={idx} className="flex items-center gap-2 p-2 bg-white rounded-lg border border-amber-100">
                                            <span className="w-6 h-6 rounded bg-amber-100 text-amber-600 flex items-center justify-center text-xs font-bold">
                                              {idx + 1}
                                            </span>
                                            <select
                                              value={classif.tipo}
                                              onChange={(e) => updateClassificacaoArranjo(anomalia.id, idx, 'tipo', e.target.value)}
                                              className="flex-1 p-2 text-sm border border-stone-200 rounded-lg bg-white focus:ring-2 focus:ring-amber-200 focus:border-amber-300"
                                            >
                                              <option value="">Selecionar tipo...</option>
                                              {tiposArranjo.sort((a, b) => (a.ordem || 0) - (b.ordem || 0)).map(t => (
                                                <option key={t.id} value={t.id}>{t.nome}</option>
                                              ))}
                                            </select>
                                            <div className="flex items-center gap-1 bg-stone-50 rounded-lg px-2">
                                              <Input
                                                type="number"
                                                min={0}
                                                max={selecionado - getTotalClassificadoArranjo(anomalia.id) + (parseInt(classif.quantidade) || 0)}
                                                value={classif.quantidade || ''}
                                                onChange={(e) => updateClassificacaoArranjo(anomalia.id, idx, 'quantidade', parseInt(e.target.value) || 0)}
                                                className="w-16 h-9 text-center font-semibold border-0 bg-transparent"
                                                placeholder="0"
                                              />
                                              <span className="text-xs text-stone-400">un</span>
                                            </div>
                                            <Button
                                              size="sm"
                                              variant="ghost"
                                              className="h-9 w-9 p-0 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg"
                                              onClick={() => removeClassificacaoArranjo(anomalia.id, idx)}
                                            >
                                              <X className="h-4 w-4" />
                                            </Button>
                                          </div>
                                        ))}
                                        
                                        {/* Botão para adicionar nova linha */}
                                        {getTotalClassificadoArranjo(anomalia.id) < selecionado && (
                                          <Button
                                            size="sm"
                                            variant="outline"
                                            className="w-full h-10 text-sm font-medium border-2 border-dashed border-amber-300 text-amber-700 hover:bg-amber-100 rounded-lg"
                                            onClick={() => addClassificacaoArranjo(anomalia.id)}
                                          >
                                            + Adicionar classificação
                                          </Button>
                                        )}
                                        
                                        {/* Aviso se não tiver todas classificadas */}
                                        {getTotalClassificadoArranjo(anomalia.id) < selecionado && (classificacoesArranjo[anomalia.id] || []).length > 0 && (
                                          <div className="flex items-center gap-2 text-xs text-amber-700 bg-amber-100/50 p-2 rounded-lg">
                                            <AlertCircle className="h-4 w-4" />
                                            Falta classificar {selecionado - getTotalClassificadoArranjo(anomalia.id)} unidade(s)
                                          </div>
                                        )}
                                        
                                        {/* Mensagem quando tudo está classificado */}
                                        {getTotalClassificadoArranjo(anomalia.id) === selecionado && selecionado > 0 && (
                                          <div className="flex items-center gap-2 text-xs text-green-700 bg-green-100/50 p-2 rounded-lg">
                                            <CheckCircle2 className="h-4 w-4" />
                                            Todas as unidades classificadas!
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ))
                    );
                  })()}
                </div>
                
                {/* PASSO 3: Resumo e Nome do Resgate (no final) */}
                <div className="mt-4 space-y-3">
                  {/* Nome do Resgate (opcional) */}
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-stone-700 flex items-center gap-2">
                      <span className="w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-xs">3</span>
                      Nome do Resgate (opcional)
                    </label>
                    <Input
                      value={nomeResgate}
                      onChange={(e) => setNomeResgate(e.target.value)}
                      placeholder="Deixe vazio para nome automático"
                      className="w-full"
                    />
                  </div>
                  
                  {/* Resumo Final */}
                  <div className="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-xs text-stone-500 uppercase tracking-wide">Resumo do Resgate</p>
                        <p className="text-sm font-medium text-stone-700 mt-1">
                          {anomaliasParaResgate.filter(a => a.of_id === ofSelecionadaResgate).length} anomalias disponíveis
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="text-xs text-stone-500 uppercase tracking-wide">Total Selecionado</p>
                        <p className="text-2xl font-bold text-blue-600">{totalSelecionadoResgate} <span className="text-sm font-normal">peças</span></p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <DialogFooter className="mt-6">
            <Button variant="outline" onClick={() => {
              setOfSelecionadaResgate('');
              setAnomaliasSelecionadasParaResgate({});
              setClassificacoesPerda({});
              setClassificacoesArranjo({});
              setNomeResgate('');
              setShowCriarResgateModal(false);
            }}>
              Cancelar
            </Button>
            <Button 
              onClick={handleCriarResgate} 
              disabled={totalSelecionadoResgate === 0 || loading || !ofSelecionadaResgate || defeitosSemClassificacao.length > 0}
              className="bg-red-600 hover:bg-red-700"
            >
              {loading ? 'A criar...' : `Criar Terceirização (${totalSelecionadoResgate} peças)`}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Adicionar Arranjo/Defeito Manualmente */}
      <Dialog open={showAdicionarAnomaliaModal} onOpenChange={(open) => {
        if (!open) {
          setNovaAnomalia({
            of_id: '',
            lote_id: '',
            operacao_id: '',
            tipo: 'arranjo',
            quantidade: 1,
            razao: '',
            observacoes: ''
          });
          setLotesOFSelecionada([]);
          setOperacoesOFSelecionada([]);
          setSearchOFAnomalia('');
        }
        setShowAdicionarAnomaliaModal(open);
      }}>
        <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <AlertTriangle className="h-5 w-5 text-amber-500" />
              Adicionar Arranjo / Defeito
            </DialogTitle>
            <DialogDescription>
              Registe manualmente um arranjo ou defeito numa Ordem de Fabrico
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            {/* Tipo */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-stone-700">Tipo de Anomalia *</label>
              <div className="grid grid-cols-2 gap-2">
                <button
                  type="button"
                  onClick={() => setNovaAnomalia(prev => ({ ...prev, tipo: 'arranjo', razao: '' }))}
                  className={`p-3 rounded-lg border-2 text-left transition-all ${
                    novaAnomalia.tipo === 'arranjo' 
                      ? 'border-amber-500 bg-amber-50' 
                      : 'border-stone-200 hover:border-stone-300'
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <Wrench className={`h-5 w-5 ${novaAnomalia.tipo === 'arranjo' ? 'text-amber-600' : 'text-stone-400'}`} />
                    <span className="font-medium">Para Arranjo</span>
                  </div>
                  <p className="text-xs text-stone-500 mt-1">Peça pode ser recuperada</p>
                </button>
                <button
                  type="button"
                  onClick={() => setNovaAnomalia(prev => ({ ...prev, tipo: 'defeito', razao: '' }))}
                  className={`p-3 rounded-lg border-2 text-left transition-all ${
                    novaAnomalia.tipo === 'defeito' 
                      ? 'border-red-500 bg-red-50' 
                      : 'border-stone-200 hover:border-stone-300'
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <XCircle className={`h-5 w-5 ${novaAnomalia.tipo === 'defeito' ? 'text-red-600' : 'text-stone-400'}`} />
                    <span className="font-medium">Defeito</span>
                  </div>
                  <p className="text-xs text-stone-500 mt-1">Perda total da peça</p>
                </button>
              </div>
            </div>
            
            {/* Selecionar OF - Com Pesquisa e Estado */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-stone-700">Ordem de Fabrico *</label>
              
              {/* Campo de pesquisa */}
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
                <Input
                  value={searchOFAnomalia}
                  onChange={(e) => setSearchOFAnomalia(e.target.value)}
                  placeholder="Pesquisar OF por número, modelo ou cliente..."
                  className="pl-9"
                />
              </div>
              
              {/* Lista de OFs filtradas */}
              <div className="border rounded-lg max-h-40 overflow-y-auto">
                {(() => {
                  const ofsFiltradas = ofs.filter(of => {
                    if (!searchOFAnomalia.trim()) return true;
                    const search = searchOFAnomalia.toLowerCase();
                    return (
                      (of.numero_of || '').toLowerCase().includes(search) ||
                      (of.artigo || '').toLowerCase().includes(search) ||
                      (of.cliente || '').toLowerCase().includes(search)
                    );
                  });
                  
                  if (ofsFiltradas.length === 0) {
                    return (
                      <div className="p-3 text-center text-stone-500 text-sm">
                        {searchOFAnomalia ? 'Nenhuma OF encontrada' : 'Nenhuma OF disponível'}
                      </div>
                    );
                  }
                  
                  return ofsFiltradas.map(of => {
                    const isSelected = novaAnomalia.of_id === of.id;
                    // Mapeamento de estados
                    const estadoLabel = {
                      'rascunho': { text: 'Rascunho', color: 'bg-stone-100 text-stone-600' },
                      'aguardar_entrada': { text: 'Aguardar', color: 'bg-yellow-100 text-yellow-700' },
                      'em_curso': { text: 'Em Curso', color: 'bg-emerald-100 text-emerald-700' },
                      'pausada': { text: 'Pausada', color: 'bg-orange-100 text-orange-700' },
                      'concluida': { text: 'Concluída', color: 'bg-sky-100 text-sky-700' },
                      'cancelada': { text: 'Cancelada', color: 'bg-red-100 text-red-700' }
                    };
                    const estado = of.estado_of || 'rascunho';
                    const estadoInfo = estadoLabel[estado] || { text: estado, color: 'bg-stone-100 text-stone-600' };
                    
                    return (
                      <button
                        key={of.id}
                        type="button"
                        onClick={() => handleOFChangeAdicionarAnomalia(of.id)}
                        className={`w-full p-2.5 text-left border-b last:border-b-0 hover:bg-stone-50 transition-colors flex items-center justify-between ${
                          isSelected ? 'bg-blue-50 border-l-4 border-l-blue-500' : ''
                        }`}
                      >
                        <div>
                          <div className="flex items-center gap-2">
                            <span className="font-medium text-navy text-sm">{of.numero_of}</span>
                            <span className={`text-xs px-1.5 py-0.5 rounded-full ${estadoInfo.color}`}>
                              {estadoInfo.text}
                            </span>
                          </div>
                          <p className="text-xs text-stone-500">{of.artigo} • {of.cliente}</p>
                        </div>
                        {isSelected && (
                          <CheckCircle2 className="h-4 w-4 text-blue-500" />
                        )}
                      </button>
                    );
                  });
                })()}
              </div>
            </div>
            
            {/* Selecionar Lote */}
            {novaAnomalia.of_id && (
              <div className="space-y-2">
                <label className="text-sm font-medium text-stone-700">Lote *</label>
                <select
                  value={novaAnomalia.lote_id}
                  onChange={(e) => setNovaAnomalia(prev => ({ ...prev, lote_id: e.target.value, quantidade: 1 }))}
                  className="w-full p-2 border rounded-lg text-sm"
                >
                  <option value="">-- Selecione um lote --</option>
                  {lotesOFSelecionada.map(lote => (
                    <option key={lote.id} value={lote.id}>
                      {lote.codigo_lote || `Lote ${lote.numero_lote}`} - {lote.quantidade} peças
                    </option>
                  ))}
                </select>
                {lotesOFSelecionada.length === 0 && (
                  <p className="text-xs text-amber-600">Esta OF não tem lotes aprovados</p>
                )}
              </div>
            )}
            
            {/* Selecionar Operação - Só aparece após selecionar Lote */}
            {novaAnomalia.of_id && novaAnomalia.lote_id && (
              <div className="space-y-2">
                <label className="text-sm font-medium text-stone-700">Operação</label>
                
                {/* Container com borda para agrupar visualmente */}
                <div className="border border-stone-200 rounded-lg overflow-hidden">
                  {/* Opção 1: Não especificar */}
                  <label 
                    className={`flex items-center gap-3 p-3 cursor-pointer transition-colors ${
                      novaAnomalia.operacao_id === 'nao_especificar' 
                        ? 'bg-blue-50 border-b-2 border-blue-400' 
                        : 'bg-stone-50 border-b border-stone-200 hover:bg-stone-100'
                    }`}
                  >
                    <input
                      type="radio"
                      name="operacao_choice"
                      checked={novaAnomalia.operacao_id === 'nao_especificar'}
                      onChange={() => setNovaAnomalia(prev => ({ ...prev, operacao_id: 'nao_especificar' }))}
                      className="h-4 w-4 text-blue-600"
                    />
                    <div>
                      <span className="font-medium text-stone-700">Não especificar operação</span>
                      <p className="text-xs text-stone-500">A anomalia não está associada a uma operação específica</p>
                    </div>
                  </label>
                  
                  {/* Opção 2: Selecionar operação */}
                  <label 
                    className={`flex items-center gap-3 p-3 cursor-pointer transition-colors ${
                      novaAnomalia.operacao_id && novaAnomalia.operacao_id !== 'nao_especificar'
                        ? 'bg-blue-50' 
                        : 'hover:bg-stone-50'
                    }`}
                  >
                    <input
                      type="radio"
                      name="operacao_choice"
                      checked={novaAnomalia.operacao_id !== 'nao_especificar' && novaAnomalia.operacao_id !== ''}
                      onChange={() => setNovaAnomalia(prev => ({ ...prev, operacao_id: '' }))}
                      className="h-4 w-4 text-blue-600"
                    />
                    <span className="font-medium text-stone-700">Selecionar operação</span>
                  </label>
                  
                  {/* Dropdown só aparece se "Selecionar operação" estiver activo */}
                  {novaAnomalia.operacao_id !== 'nao_especificar' && (
                    <div className="p-3 bg-white border-t border-stone-200">
                      <select
                        value={novaAnomalia.operacao_id}
                        onChange={(e) => setNovaAnomalia(prev => ({ ...prev, operacao_id: e.target.value }))}
                        className="w-full p-2 border rounded-lg text-sm"
                      >
                        <option value="">-- Escolha uma operação --</option>
                        {operacoesOFSelecionada.map(op => (
                          <option key={op.id} value={op.id}>
                            {op.codigo} - {op.nome}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>
            )}
            
            {/* Quantidade - Com validação do lote - Só aparece após selecionar Lote */}
            {novaAnomalia.lote_id && (
            <div className="space-y-2">
              <label className="text-sm font-medium text-stone-700">Quantidade *</label>
              {(() => {
                const loteSelecionado = lotesOFSelecionada.find(l => l.id === novaAnomalia.lote_id);
                const maxQuantidade = loteSelecionado?.quantidade || 999999;
                
                return (
                  <>
                    <Input
                      type="number"
                      min={1}
                      max={maxQuantidade}
                      value={novaAnomalia.quantidade}
                      onChange={(e) => {
                        const val = parseInt(e.target.value) || 1;
                        if (val > maxQuantidade) {
                          toast.error(`Quantidade máxima: ${maxQuantidade} peças`);
                          setNovaAnomalia(prev => ({ ...prev, quantidade: maxQuantidade }));
                        } else {
                          setNovaAnomalia(prev => ({ ...prev, quantidade: val }));
                        }
                      }}
                    />
                    {loteSelecionado && (
                      <p className="text-xs text-stone-500">
                        Máximo: <span className="font-medium">{maxQuantidade}</span> peças (tamanho do lote)
                      </p>
                    )}
                  </>
                );
              })()}
            </div>
            )}
            
            {/* Razão/Motivo - apenas para Defeitos e após selecionar Lote */}
            {novaAnomalia.tipo === 'defeito' && novaAnomalia.lote_id && (
              <div className="space-y-2">
                <label className="text-sm font-medium text-stone-700">Tipo de Defeito *</label>
                <select
                  value={novaAnomalia.razao}
                  onChange={(e) => setNovaAnomalia(prev => ({ ...prev, razao: e.target.value }))}
                  className="w-full p-2 border rounded-lg text-sm"
                >
                  <option value="">-- Selecione o tipo de defeito --</option>
                  {tiposDefeito.sort((a, b) => (a.ordem || 0) - (b.ordem || 0)).map(t => (
                    <option key={t.id} value={t.nome}>{t.nome}</option>
                  ))}
                </select>
              </div>
            )}
            
            {/* Observações - Só após selecionar Lote */}
            {novaAnomalia.lote_id && (
            <div className="space-y-2">
              <label className="text-sm font-medium text-stone-700">Observações</label>
              <Input
                value={novaAnomalia.observacoes}
                onChange={(e) => setNovaAnomalia(prev => ({ ...prev, observacoes: e.target.value }))}
                placeholder="Detalhes adicionais..."
              />
            </div>
            )}
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setShowAdicionarAnomaliaModal(false)}>
              Cancelar
            </Button>
            <Button 
              onClick={handleCriarAnomaliaManual}
              disabled={loading || !novaAnomalia.of_id || !novaAnomalia.lote_id || !novaAnomalia.operacao_id}
              className={novaAnomalia.tipo === 'arranjo' ? 'bg-amber-600 hover:bg-amber-700' : 'bg-red-600 hover:bg-red-700'}
            >
              {loading ? 'A criar...' : `Registar ${novaAnomalia.tipo === 'arranjo' ? 'Arranjo' : 'Defeito'}`}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Editar Anomalia */}
      <Dialog open={showEditAnomaliaDialog} onOpenChange={setShowEditAnomaliaDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Editar Anomalia</DialogTitle>
            <DialogDescription>
              Altere os dados da anomalia. Apenas anomalias sem peças em resgate podem ser editadas.
            </DialogDescription>
          </DialogHeader>
          {anomaliaParaAcao && (
            <div className="space-y-4 py-4">
              {/* Informação de contexto melhorada */}
              <div className="p-3 bg-stone-50 rounded-lg space-y-2 text-sm">
                {/* Linha 1: Tipo e OF */}
                <div className="flex items-center justify-between">
                  <span className={`font-medium px-2 py-0.5 rounded ${
                    anomaliaParaAcao.tipo === 'defeito' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'
                  }`}>
                    {anomaliaParaAcao.tipo === 'defeito' ? 'Defeito' : 'Arranjo'}
                  </span>
                  <span className="font-bold text-navy">OF {anomaliaParaAcao.of_numero || 'N/A'}</span>
                </div>
                
                {/* Linha 2: Cliente e Modelo */}
                <div className="grid grid-cols-2 gap-2 pt-2 border-t border-stone-200">
                  <div>
                    <p className="text-xs text-stone-500">Cliente</p>
                    <p className="font-medium text-stone-700">{anomaliaParaAcao.of_cliente || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-stone-500">Modelo</p>
                    <p className="font-medium text-stone-700">{anomaliaParaAcao.of_artigo || 'N/A'}</p>
                  </div>
                </div>
                
                {/* Linha 3: Operação e Lote */}
                <div className="grid grid-cols-2 gap-2 pt-2 border-t border-stone-200">
                  <div>
                    <p className="text-xs text-stone-500">Operação</p>
                    <p className="font-medium text-stone-700">{anomaliaParaAcao.operacao_nome || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-stone-500">Lote</p>
                    <p className="font-medium text-stone-700">{anomaliaParaAcao.lote_codigo || 'N/A'}</p>
                  </div>
                </div>
                
                {/* Linha 4: Contadores se existirem */}
                {(anomaliaParaAcao.quantidade_em_arranjo > 0 || anomaliaParaAcao.quantidade_recuperada > 0) && (
                  <div className="grid grid-cols-2 gap-2 pt-2 border-t border-stone-200">
                    {anomaliaParaAcao.quantidade_em_arranjo > 0 && (
                      <div className="text-blue-700">
                        <p className="text-xs">Em Resgate</p>
                        <p className="font-bold">{anomaliaParaAcao.quantidade_em_arranjo} peças</p>
                      </div>
                    )}
                    {anomaliaParaAcao.quantidade_recuperada > 0 && (
                      <div className="text-green-700">
                        <p className="text-xs">Recuperadas</p>
                        <p className="font-bold">{anomaliaParaAcao.quantidade_recuperada} peças</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              
              {/* Quantidade Total */}
              <div>
                <label className="text-sm font-medium text-stone-700">Quantidade Total</label>
                <Input
                  type="number"
                  min="1"
                  value={editAnomaliaData.quantidade}
                  onChange={(e) => {
                    const novaQtd = parseInt(e.target.value) || 0;
                    setEditAnomaliaData(prev => ({ 
                      ...prev, 
                      quantidade: novaQtd,
                      // Resetar classificações se a quantidade mudar
                      quantidade_defeitos: Math.min(prev.quantidade_defeitos || 0, novaQtd),
                      quantidade_arranjos: Math.min(prev.quantidade_arranjos || 0, novaQtd - Math.min(prev.quantidade_defeitos || 0, novaQtd))
                    }));
                  }}
                  className="mt-1"
                />
              </div>
              
              {/* Classificação de Quantidades */}
              <div className="bg-stone-50 rounded-lg p-4 space-y-3">
                <div className="flex items-center justify-between">
                  <label className="text-sm font-semibold text-stone-700">Classificar Quantidades</label>
                  <span className="text-xs text-stone-500">
                    Restam: {editAnomaliaData.quantidade - (editAnomaliaData.quantidade_defeitos || 0) - (editAnomaliaData.quantidade_arranjos || 0)} por classificar
                  </span>
                </div>
                
                <div className="grid grid-cols-2 gap-3">
                  {/* Defeitos */}
                  <div className="bg-white rounded-lg p-3 border border-red-200">
                    <label className="text-xs font-medium text-red-700 flex items-center gap-1">
                      <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                      Defeitos
                    </label>
                    <Input
                      type="number"
                      min="0"
                      max={editAnomaliaData.quantidade - (editAnomaliaData.quantidade_arranjos || 0)}
                      value={editAnomaliaData.quantidade_defeitos || 0}
                      onChange={(e) => {
                        const val = Math.max(0, Math.min(parseInt(e.target.value) || 0, editAnomaliaData.quantidade - (editAnomaliaData.quantidade_arranjos || 0)));
                        setEditAnomaliaData(prev => ({ ...prev, quantidade_defeitos: val }));
                      }}
                      className="mt-1 text-center font-bold"
                    />
                  </div>
                  
                  {/* Arranjos */}
                  <div className="bg-white rounded-lg p-3 border border-amber-200">
                    <label className="text-xs font-medium text-amber-700 flex items-center gap-1">
                      <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                      Para Arranjo
                    </label>
                    <Input
                      type="number"
                      min="0"
                      max={editAnomaliaData.quantidade - (editAnomaliaData.quantidade_defeitos || 0)}
                      value={editAnomaliaData.quantidade_arranjos || 0}
                      onChange={(e) => {
                        const val = Math.max(0, Math.min(parseInt(e.target.value) || 0, editAnomaliaData.quantidade - (editAnomaliaData.quantidade_defeitos || 0)));
                        setEditAnomaliaData(prev => ({ ...prev, quantidade_arranjos: val }));
                      }}
                      className="mt-1 text-center font-bold"
                    />
                  </div>
                </div>
                
                {/* Barra visual de proporção */}
                <div className="h-2 bg-stone-200 rounded-full overflow-hidden flex">
                  {editAnomaliaData.quantidade_defeitos > 0 && (
                    <div 
                      className="bg-red-500 h-full" 
                      style={{ width: `${(editAnomaliaData.quantidade_defeitos / editAnomaliaData.quantidade) * 100}%` }}
                    />
                  )}
                  {editAnomaliaData.quantidade_arranjos > 0 && (
                    <div 
                      className="bg-amber-500 h-full" 
                      style={{ width: `${(editAnomaliaData.quantidade_arranjos / editAnomaliaData.quantidade) * 100}%` }}
                    />
                  )}
                </div>
                
                {/* Validação */}
                {(editAnomaliaData.quantidade_defeitos || 0) + (editAnomaliaData.quantidade_arranjos || 0) > editAnomaliaData.quantidade && (
                  <p className="text-xs text-red-600 font-medium">
                    ⚠️ A soma excede a quantidade total!
                  </p>
                )}
              </div>
              
              {/* Observações */}
              <div>
                <label className="text-sm font-medium text-stone-700">Observações</label>
                <textarea
                  value={editAnomaliaData.observacoes}
                  onChange={(e) => setEditAnomaliaData(prev => ({ ...prev, observacoes: e.target.value }))}
                  className="mt-1 w-full p-2 border border-stone-300 rounded-md text-sm"
                  rows={2}
                  placeholder="Observações adicionais..."
                />
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowEditAnomaliaDialog(false)}>
              Cancelar
            </Button>
            <Button onClick={handleSaveEditAnomalia} disabled={loading}>
              {loading ? 'A guardar...' : 'Guardar'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Confirmar Eliminar Anomalia */}
      <Dialog open={showDeleteAnomaliaConfirm} onOpenChange={setShowDeleteAnomaliaConfirm}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="text-red-600 flex items-center gap-2">
              <Trash2 className="h-5 w-5" />
              Eliminar Anomalia
            </DialogTitle>
            <DialogDescription>
              Esta ação não pode ser revertida. A anomalia será permanentemente eliminada do sistema.
            </DialogDescription>
          </DialogHeader>
          {anomaliaParaAcao && (
            <div className="py-4 space-y-3">
              <div className="bg-red-50 rounded-lg p-4 space-y-2">
                <p className="text-sm">
                  <span className="font-medium">Tipo:</span> {anomaliaParaAcao.tipo === 'defeito' ? 'Defeito' : 'Para Arranjo'}
                </p>
                <p className="text-sm">
                  <span className="font-medium">Quantidade:</span> {anomaliaParaAcao.quantidade} peças
                </p>
                {anomaliaParaAcao.razao && (
                  <p className="text-sm">
                    <span className="font-medium">Razão:</span> {anomaliaParaAcao.razao}
                  </p>
                )}
              </div>
              
              {/* Aviso se tiver peças em arranjo */}
              {(anomaliaParaAcao.quantidade_em_arranjo > 0 || anomaliaParaAcao.quantidade_recuperada > 0) && (
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                  <p className="text-sm text-amber-800 font-medium">⚠️ Atenção:</p>
                  <ul className="text-sm text-amber-700 mt-1 list-disc list-inside">
                    {anomaliaParaAcao.quantidade_em_arranjo > 0 && (
                      <li>{anomaliaParaAcao.quantidade_em_arranjo} peças em arranjo/resgate</li>
                    )}
                    {anomaliaParaAcao.quantidade_recuperada > 0 && (
                      <li>{anomaliaParaAcao.quantidade_recuperada} peças já recuperadas</li>
                    )}
                  </ul>
                  <p className="text-xs text-amber-600 mt-2">
                    Os resgates associados permanecerão no sistema.
                  </p>
                </div>
              )}
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowDeleteAnomaliaConfirm(false)}>
              Cancelar
            </Button>
            <Button variant="destructive" onClick={handleDeleteAnomalia} disabled={loading}>
              {loading ? 'A eliminar...' : 'Eliminar'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Dialog Confirmar Arquivar Anomalia */}
      <Dialog open={showArquivarAnomaliaConfirm} onOpenChange={setShowArquivarAnomaliaConfirm}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Package className="h-5 w-5 text-amber-600" />
              Arquivar Anomalia
            </DialogTitle>
            <DialogDescription>
              A anomalia será arquivada e não aparecerá nas listagens principais, mas poderá ser consultada no histórico.
            </DialogDescription>
          </DialogHeader>
          {anomaliaParaAcao && (
            <div className="py-4 space-y-2 bg-amber-50 rounded-lg p-4">
              <p className="text-sm">
                <span className="font-medium">Tipo:</span> {anomaliaParaAcao.tipo === 'defeito' ? 'Defeito' : 'Para Arranjo'}
              </p>
              <p className="text-sm">
                <span className="font-medium">Quantidade:</span> {anomaliaParaAcao.quantidade} peças
              </p>
              {anomaliaParaAcao.razao && (
                <p className="text-sm">
                  <span className="font-medium">Razão:</span> {anomaliaParaAcao.razao}
                </p>
              )}
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowArquivarAnomaliaConfirm(false)}>
              Cancelar
            </Button>
            <Button onClick={handleArquivarAnomalia} disabled={loading} className="bg-amber-600 hover:bg-amber-700">
              {loading ? 'A arquivar...' : 'Arquivar'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </GestorLayout>
  );
}
